import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import Image from '../../Image';
import defaultProjectPlaceHolder from '../../../assets/images/project_placeholder@2x.jpg';

import { useMedia } from 'react-use';
import {
  CoordinatorsModel,
  fromRole,
  getProfileHeightString,
  getProfileWeightString,
  humanize,
  isExpired,
  isUndefinedNullEmpty,
  NoteData,
  ProfileStatusMaster,
  ProjectModel,
  RecipientProfileStatusMaster,
  RecipientsModel,
  SbCurrentUser,
  SbRecipientModel,
  SbStatusMaster,
  SubmissionBoardModel,
} from '../component/SbModel';
import { Dialog, Transition } from '@headlessui/react';
import { showToast } from '../../shared/Toast';
import FilePreviewer from '../../submission_kits/components/FilePreviewer';
import submissionBoardService from '../../services/SubmissionBoardService';
import { CheckIcon } from '@heroicons/react/24/outline';
import { Menu } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleChevronLeftIcon,
  CircleChevronRightIcon,
  DotIcon,
  ExternalLinkIcon,
  Star,
  MinusCircleIcon,
  Pin,
  PlusIcon,
  PencilLineIcon,
  XIcon,
} from 'lucide-react';
import PreferredByRecipient from '../component/PreferredByRecipent';
import Button from '../component/Button';
import { SUBMISSION_KIT_TAGS_HEADSHOT } from '../../../constants/SubmissionKit';
import CustomTabs from '../component/CustomTabs';
import { SubscriptionTier } from '../../user_plans/UserPlanModal';
import { useIsMobile } from '../component/useIsMobile';
import userService from '../../services/UserService';
import { KitDocumentModel } from '../../submission_kits/components/KitModels';
import ViewMediaModel from '../../submission_kits/components/ViewMediaModel';
import userSkillsService, { UserSkill } from '../../services/UserSkillsService';

interface SbProfileDetailProps {
  currentUser: SbCurrentUser;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  profileUser: any;
  sb_recipient?: SbRecipientModel;
  key_token?: string;
  otp_valid?: string;
  fromScreen: string;
  refreshSubmissionBoard?: () => void;
  // profileActionSave?: (profile_status: number) => void;
  dialogCloseHandler?: (open: boolean) => void;
  prevNextProfile?: (value: number) => Promise<boolean>;
}

// for recipient : director
// to show profile details: all photos, basic details
// called from SbDetailsRecipient->SbProfileItem->SbProfileDetail
export default function SbProfileDetail({
  currentUser,
  project,
  submissionBoardModel,
  profileUser,
  sb_recipient,
  key_token,
  otp_valid,
  fromScreen,
  refreshSubmissionBoard,
  // profileActionSave,
  dialogCloseHandler,
  prevNextProfile,
}: SbProfileDetailProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false); // Added loading state for updates
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbLocked, setIsSbLocked] = useState(false);
  const [isServerOperation, setIsServerOperation] = useState(false);

  const [selecteProfileUser, setSelectedProfileUser] = useState(null);
  const [sbProfileStatus, setSbProfileStatus] = useState(null);
  const [sbProfilePreferred, setSbProfilePreferred] = useState([]);

  const [isPreferredBy, setisPreferredBy] = useState(0);

  const [submissionKitMediaTag, setSubmissionKitMediaTag] = useState('');
  const [combinekitDocuments, setCombinekitDocuments] = useState([]);
  const [filterSubmissionkitDocuments, setFilterSubmissionkitDocuments] = useState(null);
  const [showConfirmationModal, setShowConfirmationDialog] = useState(false);
  const [confirmDialogActions, setConfirmDialogActions] = useState(null);

  const [addImdbShow, setaddImdbShow] = useState(false);
  const [imdbUrl, setimdbUrl] = useState('');

  const [noteTexts, setNoteTexts] = useState<NoteData[]>([]); // Updated to handle note objects
  const [noteTextsCoordinate, setNoteTextsCoordinate] = useState<NoteData[]>([]); // Updated to handle note objects
  const [noteTextsOther, setNoteTextsOther] = useState<NoteData[]>([]); // Updated to handle note objects
  const [notes, setNotes] = useState('');
  const [message, setMessage] = useState('');
  const [generalInformation, setGeneralInformation] = useState<string>('');
  const [skills, setSkills] = useState<UserSkill[]>([]);
  const scrollableDivRef = useRef<HTMLDivElement>(null);
  const [scrollable, setScrollable] = useState(false);
  const [open, setOpen] = useState(true);
  const [xsRes, setxsRes] = useState(false);
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const imdbKit = selecteProfileUser?.social_kits?.find((kit) => kit.social_type === 'imdb');
  const is_xs_res = useMedia('(min-width: 1px) and (max-width: 639px)', false);
  const isMobile = useIsMobile();
  const [tabSelected, setTabSelected] = useState<number>(is_xs_res ? 3 : 1);
  const [tabs, setTabs] = useState([]);
  const [showMediaBig, setshowMediaBig] = useState<KitDocumentModel | null>(null);

  const [submission_kit_tags, setsubmission_kit_tags] = useState([]);
  
  const tabsPopulation = () => {
    const is_xs = window.innerWidth > 1 && window.innerWidth < 639; // useMedia('(min-width: 1px) and (max-width: 639px)', false);
    let _tabs = [
      { id: 1, name: 'Info', show: true },
      { id: 4, name: 'Bio', show: true },
      {
        id: 2,
        name: 'Notes (' + noteTexts.length + ')',
        show: fromScreen !== fromRole.SB_PERFORMER && fromScreen !== fromRole.PROFILE_VIEWER,
      },
    ];
    // console.log('is_xs', is_xs);
    if (is_xs) {
      setxsRes(true);
      _tabs = [
        { id: 3, name: 'Media', show: true },
        { id: 1, name: 'Info', show: true },
        { id: 4, name: 'Bio', show: true },
        {
          id: 2,
          name: 'Notes (' + noteTexts.length + ')',
          show: fromScreen !== fromRole.SB_PERFORMER && fromScreen !== fromRole.PROFILE_VIEWER,
        },
      ];
    } else {
      setxsRes(false);
    }
    setTabs(_tabs);
  };

  useEffect(() => {
    setTabSelected(window.innerWidth > 1 && window.innerWidth < 639 ? 3 : 1);
    tabsPopulation();
    setSelectedProfileUser(profileUser);
    loadBio(profileUser?.uuid);
    // fetchRecipientProfileStatusForSB();
  }, [profileUser]);

  useEffect(() => {
    setTabSelected(window.innerWidth > 1 && window.innerWidth < 639 ? 3 : 1);
    tabsPopulation();
  }, [noteTexts, isMobile]);

  useEffect(() => {
    if (submissionBoardModel != null) {
      // setsubmission_kit_tags(submissionBoardModel.submission_kit_tags);
      if (
        submissionBoardModel.sb_status == SbStatusMaster.expired ||
        submissionBoardModel.sb_status == SbStatusMaster.locked ||
        isExpired(submissionBoardModel?.expire_at)
      ) {
        setIsSbLocked(true);
      } else {
        setIsSbLocked(false);
      }
      setSelectedSubmissionBoard(submissionBoardModel);
      for (
        let index = 0;
        submissionBoardModel.profiles && index < submissionBoardModel.profiles.length;
        index++
      ) {
        const element = submissionBoardModel.profiles[index];
        if (element.id == profileUser.id) {
          setSelectedProfileUser(element);
          break;
        }
      }
    }
  }, [submissionBoardModel]);

  useEffect(() => {
    refreshUI();
    
  }, [selecteProfileUser]);

  const loadBio = async (uuid: string) => {
    try {
      const response = await userSkillsService.getOverview(uuid);
      if (response.success) {
        setGeneralInformation(response.general_information || '');
        setSkills(response.skills || []);
      }
    } catch (err) {
      console.error('Error loading bio:', err);
    }
  };

  // Removed handleSaveBio as editing is no longer required here

  const refreshUI = () => {
    if (
      selecteProfileUser?.sb_profiles &&
      selecteProfileUser.sb_profiles?.length > 0 &&
      selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses &&
      selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses?.length > 0
    ) {
      {
        let resp = null;
        if (sb_recipient != undefined) {
          resp = selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses.find(
            (item) => item.sb_recipient_id == sb_recipient.id
          );
        } else {
          resp = selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses.find(
            (item) => item.user_id == currentUser.id
          );
          if (resp) {
          } else {
            // for a given recipient, match with recipient current selecteProfileUser id
            for (
              let indexStatus = 0;
              indexStatus < selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses.length;
              indexStatus++
            ) {
              const item = selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses[indexStatus];
              if (
                item.sb_recipient_id != null &&
                submissionBoardModel?.recipients &&
                submissionBoardModel?.recipients.length > 0
              ) {
                const resp1 = submissionBoardModel?.recipients.find(
                  (item2) =>
                    item2.sb_recipient_id == item.sb_recipient_id && item2.id == currentUser.id
                );
                if (resp1) {
                  resp = item;
                  break;
                }
              }
            }
          }
        }
        if (resp) {
          setSbProfileStatus(resp);
        } else {
          setSbProfileStatus(null);
        }
      }
      const profilePreferred = selecteProfileUser.sb_profiles[0]?.sb_profiles_statuses.filter(
        (item) => item.profile_status == 1
      );
      if (profilePreferred.length > 0) {
        setSbProfilePreferred(profilePreferred);
      } else {
        setSbProfilePreferred([]);
      }
    }
    let kitDocuments = [];
    if (
      selecteProfileUser?.sb_profiles_media &&
      selecteProfileUser.sb_profiles_media != null &&
      selecteProfileUser.sb_profiles_media.sb_profiles_medias &&
      selecteProfileUser.sb_profiles_media.sb_profiles_medias.length > 0
    ) {
      const tagVideos = selecteProfileUser.sb_profiles_media.sb_profiles_medias;
      kitDocuments = [...kitDocuments, ...tagVideos];
    }

    if (
      selecteProfileUser?.submission_kit &&
      selecteProfileUser.submission_kit != null &&
      selecteProfileUser.submission_kit.submission_kit_documents &&
      selecteProfileUser.submission_kit.submission_kit_documents.length > 0
    ) {
      let _submissionkitDocuments =
        selecteProfileUser.submission_kit.submission_kit_documents.filter((itemSkd) => {
          if (
            kitDocuments.findIndex(
              (itemKd) => itemKd.tag == itemSkd.tag && itemKd.media_status == 'Add'
            ) >= 0
          ) {
            return false;
          }
          if (
            kitDocuments.findIndex(
              (itemKd) => itemKd.tag == itemSkd.tag && itemKd.media_status == 'Remove'
            ) >= 0
          ) {
            return false;
          }
          return true;
        });
      kitDocuments = [...kitDocuments, ..._submissionkitDocuments];
    }

    // console.log(kitDocuments);
    kitDocuments = kitDocuments.filter(
      (item) => item.media_status == undefined || item.media_status !== 'Remove'
    );
    // For free/archive users defult headshot
    let isAddHeadShot = false;
    if (fromScreen === fromRole.SB_PERFORMER || fromScreen === fromRole.PROFILE_VIEWER) {
      // Performer viewing their own submission
      isAddHeadShot =
        currentUser &&
        (currentUser.subscription_tier === SubscriptionTier.free ||
          currentUser.subscription_tier === SubscriptionTier.archive);
    } else {
      // Recipient viewing performer's submission
      isAddHeadShot =
        selecteProfileUser &&
        (selecteProfileUser.subscription_tier === SubscriptionTier.free ||
          selecteProfileUser.subscription_tier === SubscriptionTier.archive);
    }

    if (
      !isAddHeadShot &&
      kitDocuments.filter(
        (item) => item.tag.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
      ).length <= 0
    ) {
      // if headshot is removed from kit
      if (
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser?.imageUrl) &&
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser.imageUrl) !==
          'icons/default_avatar.svg' &&
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser.imageUrl) !== ''
      ) {
        isAddHeadShot = true;
      }
    }
    if (isAddHeadShot) {
      const hasProfileImage =
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser?.imageUrl) &&
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser.imageUrl) !==
          'icons/default_avatar.svg' &&
        (selecteProfileUser?.croppedAvatarUrl || selecteProfileUser.imageUrl) !== '';

      if (hasProfileImage) {
        const defaultHeadshot = {
          id: -1,
          submission_kit_id: -1,
          kit_document_id: -1,
          tag: SUBMISSION_KIT_TAGS_HEADSHOT,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          kit_document: {
            id: -1,
            featured: 0,
            created_at: new Date().toISOString(),
            uuid: '',
            record_id: -1,
            file_url: selecteProfileUser?.croppedAvatarUrl || selecteProfileUser.imageUrl,
            file_name: 'headshot',
            file_content_type: 'image/jpeg',
            cropped_file_url: null,
            cropped_file_name: null,
            cropped_file_content_type: null,
            work_kit_id: null,
            wardrobe_kit_id: null,
            hair_make_up_kit_id: null,
          },
        };

        // Remove any existing headshot documents and add the default one
        kitDocuments = kitDocuments.filter(
          (item) => item.tag.toLowerCase() !== SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
        );
        kitDocuments.push(defaultHeadshot);
      }
    }

    // kitDocuments
    setCombinekitDocuments(kitDocuments);
    if(submissionBoardModel == null && fromScreen == fromRole.PROFILE_VIEWER) {
      //syca_check
      if(selecteProfileUser?.submission_kit_tags) {
        const tagsMediaPresent = kitDocuments.map((item) => {
          return item.tag.toLowerCase();
        });
        const allowedTags = selecteProfileUser?.submission_kit_tags.map((item) => {
          if(tagsMediaPresent.includes(item.name.toLowerCase()))
          {
            return  {name: item.name.toLowerCase()};
          }
        }).filter(val => val !== undefined);;
        console.log("allowedTags", allowedTags);
         setsubmission_kit_tags(allowedTags);
      } else {
        setsubmission_kit_tags(kitDocuments.map((item) => {
          return {name: item.tag.toLowerCase()}
        }));
      }
    }
    setProfileNotes();
    console.log('useEffect selecteProfileUser, setSubmissionKitMediaTag', submissionKitMediaTag);
    submissionKitTagClickHandler('');
  };

  //  total media count ( thumbnails)
  const getMediaFilesCount = () => {
    const _submission_kit_tags = selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags;
    if (!_submission_kit_tags) {
      return 0;
    }

    let count = 0;

    // Count how many tags have media (matches what's displayed as thumbnails)
    (_submission_kit_tags).forEach((tag) => {
      const hasDocument = combinekitDocuments.some(
        (doc) => doc.tag.toLowerCase() === tag.name.toLowerCase()
      );

      if (hasDocument) {
        count++;
      }
    });

    return count;
  };

  useEffect(() => {
    getMessage();
  }, [sbProfileStatus]);
  useEffect(() => {
    console.log('submissionkitDocuments', filterSubmissionkitDocuments);
  }, [filterSubmissionkitDocuments]);

  useEffect(() => {
    // console.log('swipe: useEffect, submissionKitMediaTag', submissionKitMediaTag);
    if (submissionKitMediaTag != '') {
      let kitDocuments = [];

      // Use combinekitDocuments which already has the fake headshot for free users
      if (combinekitDocuments && combinekitDocuments.length > 0) {
        const filteredDocs = combinekitDocuments.filter(
          (item) => item.tag.toLowerCase() == submissionKitMediaTag.toLowerCase()
        );
        kitDocuments = [...filteredDocs.map((item) => item.kit_document)];
        // console.log('Filtered kitDocuments from combinekitDocuments:', kitDocuments);
      }

      kitDocuments = kitDocuments.slice(0, 1);
      setFilterSubmissionkitDocuments(kitDocuments);
    } else {
      // console.log('available kit tag selectedSubmissionBoard.submission_kit_tags',
      //   submissionBoardModel.submission_kit_tags,
      //   'CombinekitDocuments', combinekitDocuments
      // )
      //  get all combinded kit doc tag
      let allDocTags: string[] = combinekitDocuments.map((item) => item.tag.toLowerCase());
      // console.log('available allDocTags', allDocTags);
      // console.log('submissionBoardModel?.submission_kit_tags', submissionBoardModel?.submission_kit_tags);
      const allSkTags = (submissionBoardModel?.submission_kit_tags || submission_kit_tags).filter((itemsk) => {
        return allDocTags.filter((itemt) => itemt == itemsk.name.toLowerCase()).length > 0;
      });
      // console.log('available allDocTags', allDocTags, 'allSkTags', allSkTags);
      // if headshot is present then only set headshot, else set first tag if present
      submissionKitTagClickHandler(
        allSkTags && allSkTags.length > 0 ? allSkTags[0].name : SUBMISSION_KIT_TAGS_HEADSHOT
      );
    }
  }, [submissionKitMediaTag, combinekitDocuments, selecteProfileUser]);

  const onCloseDialog = (value: boolean) => {
    if (showMediaBig != null) {
      return; // Prevent closing the main modal if the Big Picture modal is active
    }
    dialogCloseHandler(value);
  };
  const getMessage = () => {
    if (sbProfileStatus) {
      if (
        sbProfileStatus.profile_status == 'liked' ||
        parseInt(sbProfileStatus.profile_status) == RecipientProfileStatusMaster.Liked
      ) {
        setMessage('You already liked profile.');
        return;
      } else if (
        sbProfileStatus.profile_status == 'unliked' ||
        parseInt(sbProfileStatus.profile_status) == RecipientProfileStatusMaster.Unliked
      ) {
        setMessage('You already unliked profile.');
        return;
      }
    }
    return setMessage('');
  };
  const finalSelectionClickHandler = async () => {
    setConfirmDialogActions({
      onConfirm: async () => {
        const resp = await profileStatusSave(ProfileStatusMaster.Selected); // approved
        if (resp) {
          showToast(
            'You selected ' +
              selecteProfileUser.firstName +
              ' ' +
              selecteProfileUser.lastName +
              ' performer.',
            'success'
          );
          // Also refresh the submission board data if the function is available
          if (refreshSubmissionBoard) {
            refreshSubmissionBoard();
          }
          setShowConfirmationDialog(false);
        }
      },
      onCancel: () => {
        setShowConfirmationDialog(false);
      },
    });
    setShowConfirmationDialog(true);
  };
  const pendingClickHandler = async () => {
    if (isUpdating) return; // Prevent multiple clicks
    setIsUpdating(true);
    const resp = await profileStatusSave(ProfileStatusMaster.Pending); // pending
    if (resp) {
      // Update local state immediately after successful API call
      setSelectedProfileUser((prevUser) => ({
        ...prevUser,
        sb_profiles: [
          {
            ...prevUser.sb_profiles[0],
            profile_status: ProfileStatusMaster.Pending,
            updated_by: null, // Clear the updated_by field for pending status
          },
        ],
      }));
      showToast(
        'Removed status of  ' + selecteProfileUser.firstName + ' ' + selecteProfileUser.lastName,
        'success'
      );
      // Also refresh the submission board data if the function is available
      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }
    }
    setIsUpdating(false);
  };

  const isMaxFinalSelectedReached = () => {
    if (!selectedSubmissionBoard || !selectedSubmissionBoard.profiles) return false;
    const maxHire = selectedSubmissionBoard.multiple_hire ?? 1;
    // When multiple_hire is 0, allow 1 final selection
    const effectiveMaxHire = maxHire === 0 ? 1 : maxHire;
    const selectedCount = selectedSubmissionBoard.profiles.filter(
      (item) => item?.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Selected
    ).length;
    return selectedCount >= effectiveMaxHire;
  };
  const isProfileHidden = () => {
    return selecteProfileUser?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Rejected;
  };

  //  check if current user can hide profiles
  const isSelectionDoneHideAll = () => {
    // console.log(
    //   'isSelectionDoneHideAll profile_status',
    //   selecteProfileUser?.sb_profiles[0]?.profile_status,
    //   'submissionBoardModel.multiple_hire',
    //   submissionBoardModel?.multiple_hire
    // );
    if (selectedSubmissionBoard && selectedSubmissionBoard.multiple_hire <= 1) {
      // if any profile is sehidelected or added then hide all button
      const resp = selectedSubmissionBoard.profiles.filter((item) => {
        return (
          item?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Selected ||
          item?.sb_profiles[0]?.profile_status === ProfileStatusMaster.Onboard
        );
      });
      // When multiple_hire is 0, allow 1 final selection before hiding
      const maxAllowed = selectedSubmissionBoard.multiple_hire === 0 ? 1 : 1;
      if (resp.length >= maxAllowed) {
        // console.log('on of profile is selected or onboarded');
        return true;
      }
    }
    return false;
  };
  const profileStatusSave = async (profile_status: number) => {
    try {
      setIsServerOperation(true);
      if (
        project == undefined ||
        project == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      const response = await submissionBoardService.updatePerformerStatusSb(
        project.uuid,
        selectedSubmissionBoard.id,
        selecteProfileUser.id,
        profile_status,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : ''
      );
      return true;
    } catch (error) {
      console.error('Error selecting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to select performer, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
    return false;
  };
  const likeClickHandler = async () => {
    if (isUpdating) return; // Prevent multiple clicks during API call
    setIsUpdating(true);
    const resp = await profileActionSave(RecipientProfileStatusMaster.Liked); // liked
    if (resp) {
      showToast(
        'Liked ' + selecteProfileUser.firstName + ' ' + selecteProfileUser.lastName,
        'success'
      );
    }
    setIsUpdating(false);
  };
  const unlikeClickHandler = async () => {
    if (isUpdating) return; // Prevent multiple clicks during API call
    setIsUpdating(true);
    const resp = await profileActionSave(RecipientProfileStatusMaster.Unliked); // unliked
    if (resp) {
      showToast(
        'Unliked ' + selecteProfileUser.firstName + ' ' + selecteProfileUser.lastName,
        'success'
      );
    }
    setIsUpdating(false);
  };
  const profileActionSave = async (profile_status: number) => {
    try {
      setIsServerOperation(true);
      setSbProfileStatus(null);
      if (
        project == undefined ||
        project == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      const resp = await submissionBoardService.addRecipientFeedback(
        project.uuid,
        selectedSubmissionBoard.id,
        selecteProfileUser.id,
        sb_recipient ? sb_recipient.key_token : '',
        sb_recipient ? sb_recipient.id : 0,
        profile_status,
        notes
      );
      if (resp) {
        // console.log('resp', resp);
        if (refreshSubmissionBoard) {
          refreshSubmissionBoard();
        }

        // setSbProfileStatus(resp);
      }
      return true;
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
    return false;
  };

  const getNoteName = (user_id: number, sb_recipient_id: any) => {
    if (sb_recipient_id && sb_recipient_id != null) {
      if (submissionBoardModel?.recipients && submissionBoardModel?.recipients.length > 0) {
        const resp = submissionBoardModel?.recipients.find(
          (item) => item.sb_recipient_id == sb_recipient_id
        );
        if (resp) {
          return resp.email;
        }
      }
    } else if (user_id && user_id != null) {
      if (submissionBoardModel?.coordinators && submissionBoardModel?.coordinators.length > 0) {
        const resp = submissionBoardModel?.coordinators.find((item) => item.user_id == user_id);
        if (resp) {
          return resp.name;
        }
      }
      if (submissionBoardModel?.recipients && submissionBoardModel?.recipients.length > 0) {
        const resp = submissionBoardModel?.recipients.find((item) => item.id == user_id);
        if (resp) {
          return resp.name;
        }
      }
    }
    return '';
  };

  const setProfileNotes = () => {
    let _noteTexts = [];
    if (profileUser?.sb_profiles && profileUser?.sb_profiles.length > 0) {
      profileUser?.sb_profiles.map((item1) => {
        if (item1.note_texts && Array.isArray(item1.note_texts)) {
          _noteTexts = [..._noteTexts, ...item1.note_texts];
        }
      });
      setNoteTexts(_noteTexts);
      setNoteTextsCoordinate(
        _noteTexts.filter(
          (noteData) => noteData.note_role == null || noteData.note_role === 'coordinator'
        )
      );
      setNoteTextsOther(
        _noteTexts.filter(
          (noteData) => noteData.note_role !== null && noteData.note_role === 'selector'
        )
      );
    }
  };

  const prevNextProfileClick = async (value: number) => {
    if (prevNextProfile) {
      await prevNextProfile(value);
    }
  };
  const submissionKitTagClickHandler = async (tag: string) => {
    // console.log('swipe:', tag.toLowerCase());
    setSubmissionKitMediaTag(tag.toLowerCase());
  };
  const checkHorizontalScroll = () => {
    // tabsPopulation();
    if (scrollableDivRef.current) {
      const { scrollWidth, clientWidth } = scrollableDivRef.current;
      if (scrollWidth > clientWidth) {
        setScrollable(true);
      } else {
        setScrollable(false);
      }
    } else {
      setTimeout(() => {
        checkHorizontalScroll();
      }, 2000);
    }
  };
   const resizeWindow = () => {
    checkHorizontalScroll();
    // calculateHeight();
   }
  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
    return () => {
      window.removeEventListener('resize', resizeWindow);
    };
  }, []);
  const divMediaPreviewRef = useRef(null);
  // Commented out - widthImage state and calculateHeight function that was causing image to shrink
  // const [widthImage, setWidthImage] = useState('100%');
  // const calculateHeight = () => {
  //     if (divMediaPreviewRef.current) {
  //       // Get the current width of the div
  //       const width = divMediaPreviewRef.current.offsetWidth;
  //       let file_content_type = 'image';
  //       if(filterSubmissionkitDocuments &&
  //       filterSubmissionkitDocuments != null &&
  //       filterSubmissionkitDocuments.length > 0)
  //       {
  //         file_content_type = filterSubmissionkitDocuments[0].file_content_type;
  //       }
  //                                   // Set the height based on a 4:5 ratio (height = width * 5/4)
  //       if (file_content_type.startsWith('image')) {
  //         setWidthImage(width * (4 / 6) + 'px');
  //       } else if (file_content_type.startsWith('video')) {
  //         setWidthImage(width * (16 / 9) + 'px');
  //       }
  //     } else {
  //       setTimeout(() => {
  //         calculateHeight();
  //       }, 2000);
  //     }
  //   };
  
  //   useEffect(() => {
  //     if (dynamicHeight == undefined || dynamicHeight) {
  //       calculateHeight();
  //       window.addEventListener('resize', calculateHeight);
  //     }
  //     return () => {
  //       if (dynamicHeight == undefined || dynamicHeight) {
  //         window.removeEventListener('resize', calculateHeight);
  //       }
  //     };
  //   }, []);

  const getSelectedUser = (updated_by_user_id, profile_status, sb_recipient_id) => {
    // If profile is backup approved (status 3), show "Backup By [Name]"
    if (profile_status === ProfileStatusMaster.BackupSelected) {
      const text = 'Backup By ';
      let resp = selectedSubmissionBoard.coordinators?.find((item) => {
        return item.user_id == updated_by_user_id;
      });
      if (resp) {
        return text + (resp.name && resp.name != '' ? resp.name : resp.email);
      }
      let resp2 = selectedSubmissionBoard.recipients?.find((item) => {
        return item.id == updated_by_user_id;
      });
      if (resp2) {
        return text + (resp2.name && resp2.name != '' ? resp2.name : resp2.email);
      }
      return 'Backup';
    }
    const text = 'Selected By ';
    // check if
    if (!isUndefinedNullEmpty(sb_recipient_id)) {
      let respRec = selectedSubmissionBoard.recipients?.find((item) => {
        return item.sb_recipient_id == sb_recipient_id;
      });
      if (respRec) {
        return text + (respRec.name && respRec.name != '' ? respRec.name : respRec.email);
      }
    }

    let recipientByUserId = selectedSubmissionBoard.recipients?.find((item: RecipientsModel) => {
      return item.id == updated_by_user_id;
    });
    if (recipientByUserId) {
      return (
        text +
        (recipientByUserId.name && recipientByUserId.name != ''
          ? recipientByUserId.name
          : recipientByUserId.email)
      );
    }
    let resp = selectedSubmissionBoard.coordinators?.find((item) => {
      return item.user_id == updated_by_user_id;
    });
    if (resp) {
      const name = resp.name || resp.email;
      return text + name;
    }

    return 'Selected';
  };
  const renderNote = (noteData: NoteData, index: number, totalNotes) => {
    const name = getNoteName(noteData.user_id, noteData.sb_recipient_id);
    if (name == undefined || name == null || name.trim() == '') {
      return <></>;
    }
    return (
      <div
        key={noteData.id || index}
        className={
          ' flex flex-col pb-4 pb-1 border-dashed border-gray-200 ' +
          (index < totalNotes - 1 ? ' border-b ' : ' border-b-0 ')
        }
      >
        <div className="flex-1 flex flex-row flex-nowrap overflow-x-auto whitespace-nowrap items-center gap-1-1">
          <span className="text-xs font-bold text-black">{name}</span>
          <span
            className="font-medium text-gray-400"
            style={{
              fontSize: '0.6875rem', // 11px
            }}
          >
            {noteData.created_at}
          </span>
        </div>
        <div className="whitespace-pre-line font-normal text-xs text-black leading-relaxed">{noteData.note_text}</div>
      </div>
    );
  };
  const addToTeamClickHandler = async () => {
    try {
      setIsServerOperation(true);
      // Prepare user data for the create API
      //  sends notify_added_to_project email
      const userData = {
        user_id: selecteProfileUser.id,
        user: {
          email: selecteProfileUser.email,
          first_name: selecteProfileUser.firstName,
          last_name: selecteProfileUser.lastName,
        },
        project_id: project.uuid,
        role: 'performer',
        role_name: 'Performer',
      };
      // Call the service method to add user to project with performer role
      const response = await submissionBoardService.addUserToProject(
        project.uuid,
        userData,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : ''
      );
      // Update profile status to onboard (4) after successful API call
      await profileStatusSave(ProfileStatusMaster.Onboard); // onboard status
      showToast(
        'Successfully added ' +
          selecteProfileUser.firstName +
          ' ' +
          selecteProfileUser.lastName +
          ' to the team',
        'success'
      );
      // Note: profileStatusSave already handles count updates via callback
    } catch (error) {
      console.error('Error adding to team:', error);
      showToast(error.message || 'Failed to add to team, please try again', 'danger');
    } finally {
      setIsServerOperation(false);
    }
  };

  const [dragYProfile, setDragYProfile] = useState(0); // Tracks vertical drag distance (for visual feedback)
  // const touchStartY = useRef(0); // Stores the Y position when the touch starts
  const touchStartProfile = useRef({ x: 0, y: 0 });
  const panelRef = useRef(null);
  const MIN_SWIPE_DISTANCE = 50; // Distance in pixels to confirm a swipe-down close

  const handleTouchStartProfile = (e) => {
    // Only track single touch starts on the dialog panel itself
    if (e.touches.length === 1) {
      touchStartProfile.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      };
      ///touchStartY.current = e.touches[0].clientY;
      setDragYProfile(0); // Reset drag distance
      panelRef.current.style.transition = 'none'; // Disable transition during drag
    }
  };

  const handleTouchMoveProfile = useCallback((e) => {
    if (e.touches.length !== 1) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartProfile.current.y;

    // Only allow downward swiping (deltaY > 0)
    if (deltaY > 0) {
      e.preventDefault(); // Prevent scrolling the main page while dragging the dialog
      setDragYProfile(deltaY);

      // Apply immediate visual translation via inline style
      if (panelRef.current) {
        panelRef.current.style.transform = `translateY(${deltaY}px)`;
      }
    }
  }, []);

  const handleTouchEndProfile = useCallback(
    (e) => {
      if (e.changedTouches.length === 0) return;

      // Get the final touch position
      const touchEnd = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY,
      };

      // Calculate the total change in coordinates
      const deltaX = touchEnd.x - touchStartProfile.current.x;
      const deltaY = touchEnd.y - touchStartProfile.current.y;

      // Calculate the absolute distance moved in each axis
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // --- Check for a deliberate swipe (must move more than the minimum distance) ---
      if (absDeltaX < MIN_SWIPE_DISTANCE && absDeltaY < MIN_SWIPE_DISTANCE) {
        // console.log('Only a small movement (tap or minor drag).');
        return;
      }

      // --- 1. Determine DOMINANT axis ---
      if (absDeltaX > absDeltaY) {
        // Horizontal swipe is dominant
        if (deltaX > 0) {
          // console.log('Swipe Detected: Left-to-Right');
          prevNextProfileClick(-1);
          // Execute function for swiping right
        } else {
          // console.log('Swipe Detected: Right-to-Left');
          prevNextProfileClick(1);
          // Execute function for swiping left
        }
      } else {
        // Vertical swipe is dominant
        // if (deltaY > 0) {
        //   console.log('Swipe Detected: Top-to-Bottom (Swipe Down)');
        // } else {
        //   console.log('Swipe Detected: Bottom-to-Top (Swipe Up)');
        // }
      }

      // Re-enable smooth transition for reset/closing animation
      if (panelRef.current) {
        panelRef.current.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
        panelRef.current.style.transform = 'translateY(0)'; // Reset translation
      }
      // Reset drag state
      setDragYProfile(0);
    },
    [dragYProfile]
  );

  // media slider

  const [dragYMedia, setDragYMedia] = useState(0); // Tracks vertical drag distance (for visual feedback)
  // const touchStartY = useRef(0); // Stores the Y position when the touch starts
  const touchStartMedia = useRef({ x: 0, y: 0 });
  const handleTouchStartMedia = (e) => {
    e.stopPropagation();
    // Only track single touch starts on the dialog panel itself
    if (e.touches.length === 1) {
      touchStartMedia.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      };
      setDragYMedia(0); // Reset drag distance
      panelRef.current.style.transition = 'none'; // Disable transition during drag
    }
  };

  const handleTouchMoveMedia = useCallback((e) => {
    e.stopPropagation();
    if (e.touches.length !== 1) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartMedia.current.y;

    // Only allow downward swiping (deltaY > 0)
    if (deltaY > 0) {
      e.preventDefault(); // Prevent scrolling the main page while dragging the dialog
      setDragYMedia(deltaY);

      // Apply immediate visual translation via inline style
      // if (panelRef.current) {
      //   panelRef.current.style.transform = `translateY(${deltaY}px)`;
      // }
    }
  }, []);

  const handleTouchEndMedia = useCallback(
    (e) => {
      e.stopPropagation();
      if (e.changedTouches.length === 0) return;

      // Get the final touch position
      const touchEnd = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY,
      };

      // Calculate the total change in coordinates
      const deltaX = touchEnd.x - touchStartMedia.current.x;
      const deltaY = touchEnd.y - touchStartMedia.current.y;

      // Calculate the absolute distance moved in each axis
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // --- Check for a deliberate swipe (must move more than the minimum distance) ---
      if (absDeltaX < MIN_SWIPE_DISTANCE && absDeltaY < MIN_SWIPE_DISTANCE) {
        // console.log('Only a small movement (tap or minor drag).');
        return;
      }

      // --- 1. Determine DOMINANT axis ---
      if (absDeltaX > absDeltaY) {
        // Horizontal swipe is dominant
        if (deltaX > 0) {
          // console.log('media  Swipe Detected: Left-to-Right');
          // prevNextMediaClick(-1);
          // Execute function for swiping right
          if ((selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags)) {
            const tagsWithFile = (selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags).filter((item) => {
              return (
                combinekitDocuments.findIndex(
                  (item2) => item2.tag.toLowerCase() == item.name.toLowerCase()
                ) >= 0
              );
            });
            const index = tagsWithFile.findIndex(
              (item) => item.name.toLowerCase() == submissionKitMediaTag.toLowerCase()
            );
            if (index > 0) {
              submissionKitTagClickHandler(tagsWithFile[index - 1].name);
            } else {
              submissionKitTagClickHandler(tagsWithFile[tagsWithFile.length - 1].name);
            }
          }
        } else {
          // console.log('media Swipe Detected: Right-to-Left');
          if ((selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags)) {
            const tagsWithFile = (selectedSubmissionBoard?.submission_kit_tags||submission_kit_tags).filter((item) => {
              return (
                combinekitDocuments.findIndex(
                  (item2) => item2.tag.toLowerCase() == item.name.toLowerCase()
                ) >= 0
              );
            });

            const index = tagsWithFile.findIndex(
              (item) => item.name.toLowerCase() == submissionKitMediaTag.toLowerCase()
            );
            if (index < tagsWithFile.length - 1) {
              submissionKitTagClickHandler(tagsWithFile[index + 1].name);
            } else {
              submissionKitTagClickHandler(tagsWithFile[0].name);
            }
          }
          // prevNextMediaClick(1);
          // Execute function for swiping left
        }
      } else {
        // Vertical swipe is dominant
        // if (deltaY > 0) {
        //   console.log('Swipe Detected: Top-to-Bottom (Swipe Down)');
        // } else {
        //   console.log('Swipe Detected: Bottom-to-Top (Swipe Up)');
        // }
      }

      // Re-enable smooth transition for reset/closing animation
      // if (panelRef.current) {
      //   panelRef.current.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
      //   panelRef.current.style.transform = 'translateY(0)'; // Reset translation
      // }
      // Reset drag state
      setDragYMedia(0);
    },
    [dragYMedia]
  );

  // media slider end
  const saveSocialKit = async () => {
    const resp = await userService.imdbUrlPost(imdbUrl);
    if (resp) {
      let _selecteProfileUser = { ...selecteProfileUser };
      let socialKitIndex = _selecteProfileUser?.social_kits?.findIndex(
        (kit) => kit.social_type === 'imdb'
      );
      if (socialKitIndex >= 0) {
        _selecteProfileUser.social_kits[socialKitIndex].link_url = imdbUrl;
      } else {
        _selecteProfileUser.social_kits.push({
          social_type: 'imdb',
          link_url: imdbUrl,
        });
      }
      setSelectedProfileUser(_selecteProfileUser);
      setaddImdbShow(false);
    }
  };

  const handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      await saveSocialKit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setaddImdbShow(false);
    }
  };
  const renderMobileMedia = () => {
    return (
      <>
        <div className="flex flex-col w-full">
          {/* Media Preview */}
          <div
            className="flex flex-1 flex-col justify-center items-center overflow-hidden sm:overflow-auto bg-dark-deep-gray rounded-lg sm:px-2"
            style={
              {
                aspectRatio: isMobile?'4/5': '',
                
                // position: 'relative',
                // flex: 'none',
                // order: 0,
                // alignSelf: 'stretch',
                // flexGrow: 1,
              }
            }
            onTouchStart={handleTouchStartMedia}
            onTouchMove={handleTouchMoveMedia}
            onTouchEnd={handleTouchEndMedia}
          >
            {filterSubmissionkitDocuments &&
              filterSubmissionkitDocuments != null &&
              filterSubmissionkitDocuments.map((item, index) => {
                if (index >= 1) {
                  return <></>;
                }

                return (
                  <div
                    key={index}
                    className="flex w-full justify-center items-center"
                    style={{
                      maxWidth: isMobile ? '100%' : '18.125rem',
                    }}
                    onClick={(e) => {
                      // console.log('item', item);
                      // e.preventDefault();
                      // e.stopPropagation();
                      if (isMobile) {
                        // console.log('item', item);
                        setshowMediaBig(item);
                      }
                    }}
                  >
                    <FilePreviewer
                      object_fit="object-contain"
                      showControl={true}
                      dynamicHeight={false}
                      file_url={
                        (item.cropped_file_url || item.file_url) == 'icons/default_avatar.svg'
                          ? ''
                          : item.cropped_file_url || item.file_url
                      }
                      default_file_url={defaultProjectPlaceHolder}
                      file_name={item.file_name ?? ''}
                      file_content_type={item.file_content_type}
                    />
                    {fromScreen !== fromRole.SB_PERFORMER &&
                      fromScreen !== fromRole.PROFILE_VIEWER && (
                        <button
                          id={'sb_detail_perf_like_btn_mobile_id'}
                          type="button"
                          className="absolute top-2 right-2 rounded-full p-1 shadow-md hover:scale-110 transition-transform"
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            color: 'rgba(255, 255, 255, 0.8)',
                          }}
                          onClick={async (e) => {
                            e.stopPropagation();
                            if (
                              sbProfileStatus?.profile_status == 'liked' ||
                              parseInt(sbProfileStatus?.profile_status) ==
                                RecipientProfileStatusMaster.Liked
                            ) {
                              await unlikeClickHandler();
                            } else {
                              await likeClickHandler();
                            }
                          }}
                          disabled={isUpdating}
                        >
                          <div className="h-5 w-5">
                            {sbProfileStatus?.profile_status == 'liked' ||
                            parseInt(sbProfileStatus?.profile_status) ==
                              RecipientProfileStatusMaster.Liked ? (
                              <Star fill="white" className="h-5 w-5" />
                            ) : (
                              <Star className="h-5 w-5" />
                            )}
                          </div>
                        </button>
                      )}
                  </div>
                );
              })}
          </div>
          <div className="pt-5 pb-3 flex items-center justify-center">
            <div className="flex font-medium text-sm">Media Files ({getMediaFilesCount()}):</div>
          </div>
          <div className="flex flex-row justify-center items-center p-0 gap-5">
            <div
              className="w-8 h-8 text-gray-300"
              onClick={() => {
                if (selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags) {
                  const tagsWithFile = (
                    selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags
                  ).filter((item) => {
                    return (
                      combinekitDocuments.findIndex(
                        (item2) => item2.tag.toLowerCase() == item.name.toLowerCase()
                      ) >= 0
                    );
                  });
                  const index = tagsWithFile.findIndex(
                    (item) => item.name.toLowerCase() == submissionKitMediaTag.toLowerCase()
                  );
                  if (index > 0) {
                    submissionKitTagClickHandler(tagsWithFile[index - 1].name);
                  } else {
                    submissionKitTagClickHandler(tagsWithFile[tagsWithFile.length - 1].name);
                  }
                }
              }}
            >
              <CircleChevronLeftIcon className="w-8 h-8" />
            </div>
            <div className="flex flex-row justify-center items-center p-0 gap-2-1 ">
              {(
                (selectedSubmissionBoard && selectedSubmissionBoard?.submission_kit_tags) ||
                submission_kit_tags
              ).map((item, indexKit) => {
                let thumbDoc = null;
                // Find thumbnail document
                if (combinekitDocuments && combinekitDocuments.length > 0) {
                  const match = combinekitDocuments.find(
                    (doc) => doc.tag.toLowerCase() === item.name.toLowerCase()
                  );
                  if (match) {
                    thumbDoc = match.kit_document;
                  }
                }
                if (thumbDoc == null) {
                  return <></>;
                }
                return (
                  // <button
                  //   key={indexKit}
                  //   id={indexKit + '_id'}
                  //   className={`flex-shrink-0 flex flex-col items-center justify-end text-xs rounded-lg bg-white hover:bg-gray-50 overflow-hidden transition-all duration-200 ${
                  //     submissionKitMediaTag.toLowerCase() ===
                  //     item.name.toLowerCase()
                  //       ? 'border-0 ' // 'border-1 border-blue-500 ring-2 ring-blue-200'
                  //       : 'border-0 '
                  //   }`}
                  <>
                    {thumbDoc && (
                      <div
                        className={
                          'w-4 h-4 rounded-full ' +
                          (submissionKitMediaTag.toLowerCase() === item.name.toLowerCase()
                            ? 'text-blue-500 bg-blue-500'
                            : 'text-gray-200 bg-gray-200')
                        }
                        onClick={async (e) => {
                          e.stopPropagation();
                          await submissionKitTagClickHandler(item.name);
                        }}
                      >
                        <DotIcon className="w-4 h-4" strokeWidth={'1rem'} />
                      </div>
                    )}
                  </>
                  //  </button>
                );
              })}
            </div>
            <div
              className="w-8 h-8 text-gray-300"
              onClick={() => {
                if (selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags) {
                  const tagsWithFile = (
                    selectedSubmissionBoard?.submission_kit_tags || submission_kit_tags
                  ).filter((item) => {
                    return (
                      combinekitDocuments.findIndex(
                        (item2) => item2.tag.toLowerCase() == item.name.toLowerCase()
                      ) >= 0
                    );
                  });

                  const index = tagsWithFile.findIndex(
                    (item) => item.name.toLowerCase() == submissionKitMediaTag.toLowerCase()
                  );
                  if (index < tagsWithFile.length - 1) {
                    submissionKitTagClickHandler(tagsWithFile[index + 1].name);
                  } else {
                    submissionKitTagClickHandler(tagsWithFile[0].name);
                  }
                }
              }}
            >
              <CircleChevronRightIcon className="w-8 h-8" />
            </div>
          </div>
          {/* Media Preview */}
        </div>
      </>
    );
  };
  const DialogPanelInnerRender = () => {
    return (
      <>
        {/* Left Arrow */}
        {fromScreen !== fromRole.SB_PERFORMER && fromScreen !== fromRole.PROFILE_VIEWER && (
          <>
            <button
              id="prev_profile_id"
              type="button"
              onClick={() => prevNextProfileClick(-1)}
              className="absolute top-1/2 -left-16 transform -translate-y-1/2
                        hidden sm:flex h-10 w-10 items-center justify-center 
                          rounded-full bg-white shadow-md hover:bg-gray-100 text-gray-600"
            >
              <ChevronLeftIcon className="h-6 w-6" />
            </button>
            {/* Right Arrow */}
            <button
              id="next_profile_id"
              type="button"
              onClick={() => prevNextProfileClick(1)}
              className="absolute top-1/2 -right-16 transform -translate-y-1/2
                        hidden sm:flex h-10 w-10 items-center justify-center 
                          rounded-full bg-white shadow-md hover:bg-gray-100 text-gray-600"
            >
              <ChevronRightIcon className="h-6 w-6" />
            </button>
          </>
        )}

        <div className="h-full sm:scrollable-content sm:overflow-y-auto justify-items-center">
          {selecteProfileUser != null && (
            <div className="flex w-full h-full flex-col ">
              <div className="flex flex-col h-full justify-items-center gap-0 ">
                {/* title close button */}
                <div className="flex w-full px-6 flex-row justify-between text-lg font-medium text-gray-900">
                  <div className="">{selectedSubmissionBoard?.title}</div>
                  <div className="">
                    {/* Close Button */}
                    {fromScreen != fromRole.PROFILE_VIEWER && (
                      <button
                        id={'sb_detail_perf_close_btn_id'}
                        onClick={() => onCloseDialog(false)}
                        className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-100 text-gray-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={2}
                          stroke="currentColor"
                          className="h-6 w-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
                {/* title close button */}
                {/* Adaptable Button-Card FLOW  */}
                <div
                  className={"flex w-full  gap-10 scrollable-content overflow-y-auto " + (fromScreen === fromRole.PROFILE_VIEWER ? '' : 'px-6')
                    + (isMobile ? ' flex-col ' : ' flex-row ')
                  }
                  style={{
                    flex: xsRes ? 'flex' : 'none',
                    order: 1,
                    alignSelf: 'stretch',
                    flexGrow: 1,
                  }}
                >
                  {
                  isMobile && fromScreen === fromRole.PROFILE_VIEWER  && renderMobileMedia()
                  }
                  {/* Frame 31 */}
                  {true && (
                    <div
                      className={
                        'hidden sm:flex flex-1 flex-col bg-white ' +
                        (fromScreen === fromRole.SB_CREATOR ||
                        fromScreen === fromRole.RECIPIENT ||
                        // fromScreen === fromRole.PROFILE_VIEWER ||
                        fromScreen === fromRole.SB_EXTERNAL_RECIPIENT
                          ? ' w-full '
                          : '')
                      }
                    >
                      {/* Media Preview */}
                      <div
                        className="flex flex-1 flex-col justify-center items-center  bg-dark-deep-gray rounded-lg overflow-hidden"
                        ref={divMediaPreviewRef}
                       style={{
                          maxWidth: '100%',
                          maxHeight: '33.75rem',
                          position: 'relative',
                          flex: 'none',
                          order: 0,
                          alignSelf: 'stretch',
                          flexGrow: 1,
                        }}
                      >
                        {filterSubmissionkitDocuments &&
                          filterSubmissionkitDocuments != null &&
                          filterSubmissionkitDocuments.map((item, index) => {
                            if (index >= 1) {
                              return <></>;
                            }
                            if (
                              item?.file_content_type &&
                              item.file_content_type.indexOf('image/') == 0
                            ) {
                              let image_url = item.cropped_file_url || item.file_url;
                              return (
                                <div
                                  key={index}
                                  className="photo-item w-full h-full flex items-center justify-center cursor-pointer"
                                  meta-name={item.file_url}
                                  style={{
                                    position: 'absolute',
                                    inset: 0,
                                  }}
                                  onClick={() => setshowMediaBig(item)}
                                >
                                  <FilePreviewer
                                    object_fit="object-contain"
                                    showControl={true}
                                    dynamicHeight={false}
                                    file_url={
                                      image_url == 'icons/default_avatar.svg' ? '' : image_url
                                    }
                                    default_file_url={defaultProjectPlaceHolder}
                                    file_name={''}
                                    file_content_type={item.file_content_type}
                                  />
                                  {/* <Image
                                      alt={`Submission document ${index}` + image_url}
                                      src={image_url == 'icons/default_avatar.svg' ? '' : image_url}
                                      fallbackSrc={defaultProjectPlaceHolder}
                                      className="w-full h-full object-contain"
                                      style={{
                                        position: 'absolute',
                                        left: '0%',
                                        right: '0%',
                                        top: '0%',
                                        bottom: '0%',
                                      }}
                                    /> */}
                                    {/* <img
                                            src={item.cropped_file_url || item.file_url}
                                            alt={`Submission document ${index}`}
                                            className="w-full h-full object-contain"
                                            style={{
                                              position: 'absolute',
                                              left: '0%',
                                              right: '0%',
                                              top: '0%',
                                              bottom: '0%',
                                            }}
                                            onError={(e) => {
                                              // This will log an error if the image fails to load
                                              console.error(
                                                'Image failed to load:',
                                                item.file_url,
                                                e
                                              );
                                            }}
                                          /> */}
                                  {/* removed anchor tag */}
                                  {/* Like Button Start */}
                                  {
                                    fromScreen !== fromRole.SB_PERFORMER &&
                                    fromScreen !== fromRole.PROFILE_VIEWER && (
                                      <button
                                        id={'sb_detail_perf_like_btn_id'}
                                        type="button"
                                        className="absolute top-2 right-2 rounded-full p-1 shadow-md hover:scale-110 transition-transform"
                                        style={{
                                          backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                          color: 'rgba(255, 255, 255, 0.8)',
                                        }}
                                        onClick={async (e) => {
                                          // console.log('like clicked');
                                          e.stopPropagation();
                                          if (
                                            sbProfileStatus?.profile_status == 'liked' ||
                                            parseInt(sbProfileStatus?.profile_status) ==
                                              RecipientProfileStatusMaster.Liked
                                          ) {
                                            await unlikeClickHandler();
                                          } else {
                                            await likeClickHandler();
                                          }
                                        }}
                                        disabled={isUpdating} // Disable during API calls
                                      >
                                        <div className="h-5 w-5">
                                          {sbProfileStatus?.profile_status == 'liked' ||
                                          parseInt(sbProfileStatus?.profile_status) ==
                                            RecipientProfileStatusMaster.Liked ? (
                                            <Star fill="white" className="h-5 w-5" />
                                          ) : (
                                            <Star className="h-5 w-5" />
                                          )}
                                        </div>
                                      </button>
                                    )}
                                  {/* Like Button End */}
                                </div>
                              );
                            }
                            return (
                              <div key={index} className="flex w-full justify-center items-center">
                                <FilePreviewer
                                  file_url={item.file_url}
                                  poster_url={item.cropped_file_url}
                                  object_fit='object-contain'
                                  file_name={item.file_name ?? ''}
                                  file_content_type={item.file_content_type}
                                  // dynamicHeight={false}
                                  showControl={true}

                                  // file_url={
                                  //   (item.cropped_file_url || item.file_url) ==
                                  //   'icons/default_avatar.svg'
                                  //     ? ''
                                  //     : item.cropped_file_url || item.file_url
                                  // }
                                  // default_file_url={defaultProjectPlaceHolder}
                                  // file_name={item.file_name ?? ''}
                                  // file_content_type={item.file_content_type} 
                                />
                              </div>
                            );
                          })}
                      </div>
                      {/* Media Preview */}
                      {/* Frame 36 */}
                      <div
                        className="pt-5 pb-3 flex items-center justify-center"
                        style={{
                          flex: 'none',
                          order: 1,
                          alignSelf: 'stretch',
                          flexGrow: 0,
                        }}
                      >
                        <div className="flex font-medium text-sm">
                          Media Files ({getMediaFilesCount()}):
                        </div>
                      </div>
                      {/* Frame 36 */}
                      {/* Thumbnail Navigation */}
                      {/* Gallery Thumbnails v2 */}
                      <div
                        className="flex flex-1 flex-col rounded-lg px-2"
                        style={{
                          flex: 'none',
                          order: 2,
                          alignSelf: 'stretch',
                          flexGrow: 0,
                        }}
                      >
                        <div className="gap-2 flex justify-center flex-wrap flex-row items-center">
                          <div
                            className={
                              'relative flex w-full ' +
                              (scrollable ? 'justify-start' : 'justify-center')
                            }
                          >
                            {/* Left Scroll Button */}
                            {scrollable && (
                              <button
                                type="button"
                                // className="absolute left-0 top-8 -translate-y-1/2 z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                className="z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                onClick={() => {
                                  const container = document.getElementById('thumbScroll');
                                  if (container) {
                                    const scrollAmount = 80;
                                    container.scrollBy({
                                      left: -scrollAmount,
                                      behavior: 'smooth',
                                    });
                                  }
                                }}
                              >
                                <ChevronLeftIcon className="h-4 w-4 text-gray-600" />
                              </button>
                            )}
                            {/* Scrollable Thumbnails Container */}
                            <div
                              ref={scrollableDivRef}
                              id="thumbScroll"
                              className={
                                'flex  gap-2 overflow-hidden scroll-smooth ' +
                                (scrollable ? 'justify-start' : 'justify-center')
                              }
                              style={{
                                // width: '456',
                                scrollBehavior: 'smooth',
                              }}
                            >
                              {/* {[1, 2, 3, 4].map((item2) => {
                                      return (
                                        <> */}
                              {/* IMAGES - Left side */}
                              {((selectedSubmissionBoard && selectedSubmissionBoard?.submission_kit_tags) || submission_kit_tags)
                                .filter((item) => {
                                  const match = combinekitDocuments?.find((doc) => doc.tag.toLowerCase() === item.name.toLowerCase());
                                  return match?.kit_document?.file_content_type?.startsWith('image/');
                                })
                                .map((item, indexKit) => {
                                  const thumbDoc = combinekitDocuments?.find((doc) => doc.tag.toLowerCase() === item.name.toLowerCase())?.kit_document;
                                  if (!thumbDoc) return null;
                                  return (
                                    <button key={'img_' + indexKit} id={indexKit + '_img_id'} className={`flex-shrink-0 flex flex-col items-center justify-end text-xs rounded-lg bg-white hover:bg-gray-50 overflow-hidden transition-all duration-200 ${submissionKitMediaTag.toLowerCase() === item.name.toLowerCase() ? 'border-0 ' : 'border-0 '}`} onClick={async (e) => { e.stopPropagation(); await submissionKitTagClickHandler(item.name); }}>
                                      <div className="flex flex-1 items-center justify-center overflow-hidden w-full relative rounded-lg" style={{ width: '3.75rem' }}>
                                        <div className="w-full flex items-center justify-center bg-dark-deep-gray rounded-lg overflow-hidden">
                                          <FilePreviewer showControl={false} file_url={(thumbDoc.cropped_file_url || thumbDoc.file_url) == 'icons/default_avatar.svg' ? '' : thumbDoc.cropped_file_url || thumbDoc.file_url} default_file_url={defaultProjectPlaceHolder} file_name={thumbDoc.file_name ?? ''} file_content_type={thumbDoc.file_content_type} />
                                        </div>
                                      </div>
                                      <span className="px-1 py-1 font-medium text-center truncate w-full" style={{ fontSize: '0.5rem' }}>{humanize(item.name)}</span>
                                    </button>
                                  );
                                })}
                              {/* DIVIDER - between images and videos */}
                              {combinekitDocuments?.some(doc => doc.kit_document?.file_content_type?.startsWith('image/')) && combinekitDocuments?.some(doc => doc.kit_document?.file_content_type?.startsWith('video/')) && (
                                <div className="h-20 w-px bg-gray-300 mx-2 flex-shrink-0"></div>
                              )}
                              {/* VIDEOS - Right side */}
                              {((selectedSubmissionBoard && selectedSubmissionBoard?.submission_kit_tags) || submission_kit_tags)
                                .filter((item) => {
                                  const match = combinekitDocuments?.find((doc) => doc.tag.toLowerCase() === item.name.toLowerCase());
                                  return match?.kit_document?.file_content_type?.startsWith('video/');
                                })
                                .map((item, indexKit) => {
                                  const thumbDoc = combinekitDocuments?.find((doc) => doc.tag.toLowerCase() === item.name.toLowerCase())?.kit_document;
                                  if (!thumbDoc) return null;
                                  return (
                                    <button key={'vid_' + indexKit} id={indexKit + '_vid_id'} className={`flex-shrink-0 flex flex-col items-center justify-end text-xs rounded-lg bg-white hover:bg-gray-50 overflow-hidden transition-all duration-200 ${submissionKitMediaTag.toLowerCase() === item.name.toLowerCase() ? 'border-0 ' : 'border-0 '}`} onClick={async (e) => { e.stopPropagation(); await submissionKitTagClickHandler(item.name); }}>
                                      <div className="flex flex-1 items-center justify-center overflow-hidden w-full relative rounded-lg" style={{ width: '6.255rem' }}>
                                        <div className="w-full flex items-center justify-center bg-dark-deep-gray rounded-lg overflow-hidden">
                                          <FilePreviewer 
                                          file_url={thumbDoc.file_url}
                                          poster_url={thumbDoc.cropped_file_url}
                                          object_fit='object-contain'
                                          file_name={thumbDoc.file_name ?? ''}
                                          file_content_type={thumbDoc.file_content_type}
                                          // dynamicHeight={false}
                                          showControl={false}
                                          default_file_url={defaultProjectPlaceHolder}                                           

                                          // showControl={false} 
                                          // file_url={(thumbDoc.cropped_file_url || thumbDoc.file_url) == 'icons/default_avatar.svg' ? '' : thumbDoc.cropped_file_url || thumbDoc.file_url} 
                                          // default_file_url={defaultProjectPlaceHolder} 
                                          // file_name={thumbDoc.file_name ?? ''} 
                                          // file_content_type={thumbDoc.file_content_type}
                                          />
                                        </div>
                                      </div>
                                      <span className="px-1 py-1 font-medium text-center truncate w-full" style={{ fontSize: '0.5rem' }}>{humanize(item.name)}</span>
                                    </button>
                                  );
                                })}
                              {/* </>
                                      );
                                    })} */}
                            </div>
                            {/* Right Scroll Button */}
                            {scrollable && (
                              <button
                                type="button"
                                // className="absolute right-0 top-8 -translate-y-1/2 z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                className="z-20 bg-white p-2 rounded-full border-0 hover:bg-gray-50 transition-all"
                                onClick={() => {
                                  const container = document.getElementById('thumbScroll');
                                  if (container) {
                                    const scrollAmount = 80;
                                    container.scrollBy({
                                      left: scrollAmount,
                                      behavior: 'smooth',
                                    });
                                  }
                                }}
                              >
                                <ChevronRightIcon className="h-4 w-4 text-gray-600" />
                                {/* <ArrowRightIcon className="h-4 w-4 text-gray-600" /> */}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* Gallery Thumbnails v2 */}
                    </div>
                  )}
                  {/* Frame 31 */}
                  {/* CARD right profile info panel */}
                  {true &&
                    (fromScreen === fromRole.SB_CREATOR ||
                      fromScreen === fromRole.RECIPIENT ||
                      fromScreen === fromRole.SB_EXTERNAL_RECIPIENT ||
                      // fromScreen === fromRole.PROFILE_VIEWER ||
                      fromScreen === fromRole.SB_PERFORMER) && (
                      <div
                        className="flex w-full sm:w-1/3 flex-col bg-white rounded-lg gap-4 shadow-sm h-full sm:px-4"
                        style={{}}
                      >
                        {/* Name */}
                        <div
                          className=" text-2xl font-semibold primary-color gap-4 flex justify-between items-center"
                          style={{
                            padding: isMobile ? 'none' : '0px 0px 20px',
                            flex: 'none',
                            order: 0,
                            alignSelf: 'stretch',
                            flexGrow: 0,
                          }}
                        >
                          {selecteProfileUser.firstName} {selecteProfileUser.lastName}
                          {/* Three Dots on Right Side */}
                          {fromScreen === fromRole.SB_CREATOR && (
                            <Menu as="div" className="relative inline-block text-left">
                              <Menu.Button
                                id={'sb_detail_perf_dots_btn_id'}
                                className="flex h-10 w-10 items-center justify-center 
                                            rounded-full hover:bg-gray-100 transition 
                                            text-gray-500"
                              >
                                <EllipsisVerticalIcon className="h-6 w-6" />
                              </Menu.Button>

                              <Menu.Items
                                className="absolute right-0 mt-2 w-48 origin-top-right 
                                            rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 
                                            focus:outline-none z-20"
                              >
                                <div className="py-1 gap-1 flex flex-col">
                                  <Menu.Item>
                                    {({ active }) => (
                                      <a
                                        id={'sb_detail_perf_view_profile_btn_id'}
                                        href={`/users/${selecteProfileUser.uuid}?from=sb&project_id=${project.uuid}&sb_id=${selectedSubmissionBoard.id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={`block px-4 py-2 text-sm ${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                          }`}
                                      >
                                        View Profile
                                      </a>
                                    )}
                                  </Menu.Item>
                                </div>
                              </Menu.Items>
                            </Menu>
                          )}
                        </div>
                        {/* Tabs */}
                        {(fromScreen === fromRole.SB_CREATOR ||
                          fromScreen === fromRole.RECIPIENT ||
                          fromScreen === fromRole.SB_PERFORMER ||
                          fromScreen === fromRole.PROFILE_VIEWER ||
                          fromScreen === fromRole.SB_EXTERNAL_RECIPIENT) && (
                            <div
                              className="  gap-4 flex justify-between items-center border-b border-gray-200"
                              style={{
                                flex: 'none',
                                order: 0,
                                alignSelf: 'stretch',
                                flexGrow: 0,
                              }}
                            >
                              <div className="text-sm font-medium primary-color w-full flex flex-row text-center">
                                <CustomTabs
                                  tabSelected={tabSelected}
                                  tabs={tabs}
                                  tabSelectHandler={function (id: number): void {
                                    setTabSelected(id);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        {/* Tabs end */}
                        {/* Frame 89  */}

                        {(tabSelected == 1 || tabSelected == 2 || tabSelected == 3 || tabSelected == 4) && (
                          <div
                            className="flex flex-col gap-4"
                            style={{
                              overflow: 'clip',
                              position: 'relative',
                              flex: 'none',
                              order: 1,
                              alignSelf: 'stretch',
                              flexGrow: 1,
                            }}
                          >
                            {/* Frame 88 */}
                            <div
                              className="flex flex-col w-full items-start gap-4 scrollable-content overflow-y-auto"
                              style={{
                                position: xsRes ? 'relative' : 'absolute',
                                flex: 'none',
                                order: 0,
                                alignSelf: 'stretch',
                                flexGrow: 0,
                                zIndex: 0,
                                height: '100%',
                                // height: 522,
                              }}
                            >
                              {tabSelected == 1 && (
                                <>
                                  {/* Gender / Height / Weight / Ethnicity / Hair / Eyes */}
                                  <div className="flex w-full">
                                    <div className="grid grid-cols-2 gap-4 w-full">
                                      <div className="flex flex-col">
                                        <span className="text-11 font-semibold text-gray-500">
                                          Gender
                                        </span>
                                        <span className="text-13 text-gray-900">
                                          {humanize(selecteProfileUser.gender)}
                                        </span>
                                      </div>
                                      <div className="flex flex-col">
                                        <span className="text-11 font-semibold  text-gray-500">
                                          Height / Weight
                                        </span>
                                        <span className="text-13 text-gray-900">
                                          {getProfileHeightString(selecteProfileUser, currentUser)}
                                          {isUndefinedNullEmpty(getProfileHeightString(selecteProfileUser, currentUser)) ||
                                          isUndefinedNullEmpty(getProfileWeightString(selecteProfileUser, currentUser))
                                            ? ''
                                            : ' / '}{' '}
                                          {getProfileWeightString(selecteProfileUser, currentUser)}
                                        </span>
                                      </div>
                                      <div className="flex flex-col">
                                        <span className="text-11 font-semibold  text-gray-500">
                                          Ethnicity
                                        </span>
                                        <span className="text-13 text-gray-900">
                                          {selecteProfileUser.ethnicities
                                            ? humanize(selecteProfileUser.ethnicities.join(', '))
                                            : ''}
                                        </span>
                                      </div>
                                      <div className="flex flex-col">
                                        <span className="text-11 font-semibold text-gray-500">
                                          Hair / Eyes
                                        </span>
                                        <span className="text-13 text-gray-900">
                                          {humanize(
                                            selecteProfileUser?.hair_make_up_kit?.hair_color
                                          )}{' '}
                                          {isUndefinedNullEmpty(
                                            selecteProfileUser?.hair_make_up_kit?.eye_color
                                          ) ||
                                          isUndefinedNullEmpty(
                                            selecteProfileUser?.hair_make_up_kit?.hair_color
                                          )
                                            ? ''
                                            : '/'}{' '}
                                          {humanize(
                                            selecteProfileUser?.hair_make_up_kit?.eye_color
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <hr className="my-4 w-full" />
                                  {/* Contact */}
                                  <div className="flex flex-col items-start">
                                    <div className="flex items-center leading-6">
                                      <span className="w-16 text-11 font-semibold text-gray-500">
                                        Email
                                      </span>
                                      <a href={`mailto:${selecteProfileUser?.email}`}>
                                        <span className="text-13 text-gray-900">
                                          {selecteProfileUser?.email}
                                        </span>
                                      </a>
                                    </div>
                                    <div className="flex items-center leading-6">
                                      <span className="w-16 text-11 font-semibold text-gray-500">
                                        Phone
                                      </span>
                                      <a href={`phone:${selecteProfileUser?.cell_phone}`}>
                                        <span className="text-13 text-gray-900">
                                          {selecteProfileUser?.cell_phone}
                                        </span>
                                      </a>
                                    </div>
                                    {fromScreen === fromRole.SB_PERFORMER && (
                                      <div className="flex items-center text-sm leading-6">
                                        <span className="w-16 text-11 font-semibold text-gray-500">
                                          IMDb
                                        </span>
                                        {currentUser.subscription_tier == 'free' ? (
                                          <>
                                            <div
                                              className="cursor-pointer flex flex-row items-center gap-1 ring-0-3-6-2-25 hover:shadow-ring-0-3-6-2-25  active:bg-gray-100"
                                              style={{
                                                padding: '3px 8px 3px 3px',
                                                minHeight: '1.5rem',
                                                border: '1px dashed #D1D5DB',
                                                // border: '1px dashed #F6C700',
                                                borderRadius: '0.5rem',
                                                flex: 'none',
                                                order: 2,
                                                flexGrow: 0,
                                              }}
                                              onClick={() => {
                                                window.location.href = '/user_plans';
                                              }}
                                            >
                                              <div
                                                className="flex flex-row items-start gap-2-1 "
                                                style={{
                                                  padding: '4px 6px',
                                                  background: '#F6C700',
                                                  opacity: '0.4',
                                                  borderRadius: '5px 0px 0px 5px',
                                                  flex: 'none',
                                                  order: 0,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                <svg
                                                  width="31"
                                                  height="16"
                                                  viewBox="0 0 31 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <g clip-path="url(#clip0_6867_3112)">
                                                    <path
                                                      d="M31 1.37515C30.9159 0.670738 30.4053 0.109305 29.7551 0C26.9053 0 4.1071 0 1.25725 0C0.545061 0.119794 0 0.7817 0 1.57941C0 2.86182 0 13.1189 0 14.4007C0 15.284 0.666904 16 1.49016 16C4.2931 16 26.7193 16 29.5222 16C30.2803 16 30.9062 15.3922 31 14.6055C31 11.9596 31 2.69786 31 1.37515Z"
                                                      fill="#F6C700"
                                                    />
                                                    <path
                                                      d="M3.74219 3.21484H6.20224V12.9116H3.74219V3.21484Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M10.8443 7.68147C10.6329 6.20364 10.5154 5.38219 10.4922 5.21823C10.3892 4.42715 10.2911 3.73875 10.1973 3.15137C9.98435 3.15137 8.92173 3.15137 7.00781 3.15137V12.8481H9.16272L9.17026 6.44544L10.0771 12.8481H11.612L12.4719 6.30301L12.48 12.8481H14.6279V3.15137H11.4141L10.8443 7.68147Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M18.6922 5.16855C18.7191 5.29221 18.7332 5.57265 18.7332 6.01097C18.7332 6.38692 18.7332 9.39448 18.7332 9.77042C18.7332 10.4158 18.6922 10.811 18.6108 10.9568C18.5288 11.1025 18.311 11.1748 17.9579 11.1748C17.9579 10.5383 17.9579 5.44623 17.9579 4.80972C18.2258 4.80972 18.4086 4.83898 18.5057 4.89639C18.6027 4.95436 18.6652 5.04489 18.6922 5.16855ZM19.8033 12.7493C20.0961 12.6836 20.3419 12.5676 20.5414 12.4026C20.7403 12.237 20.88 12.0079 20.9598 11.7147C21.0401 11.4221 21.0875 10.8408 21.0875 9.97137C21.0875 9.6313 21.0875 6.90695 21.0875 6.56633C21.0875 5.64883 21.0525 5.03385 20.9981 4.72139C20.9431 4.40838 20.8067 4.12408 20.5883 3.86903C20.3694 3.61398 20.0503 3.4307 19.6308 3.31919C19.2108 3.20768 18.5261 3.15137 17.3352 3.15137C17.2128 3.15137 16.6014 3.15137 15.5 3.15137V12.8481H18.4803C19.1672 12.826 19.6082 12.7934 19.8033 12.7493Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M25.0531 11.3006C25.0079 11.4237 24.8095 11.4861 24.6596 11.4861C24.5129 11.4861 24.4154 11.4265 24.3658 11.3067C24.3162 11.1875 24.2919 10.9153 24.2919 10.4891C24.2919 10.233 24.2919 8.18266 24.2919 7.92651C24.2919 7.48487 24.3135 7.2094 24.3571 7.09954C24.4003 6.99079 24.4951 6.93558 24.6418 6.93558C24.7917 6.93558 24.9928 6.99796 25.0445 7.12328C25.0957 7.24859 25.1216 7.51634 25.1216 7.92651C25.1216 8.09212 25.1216 8.92019 25.1216 10.4113C25.106 10.9219 25.0833 11.2184 25.0531 11.3006ZM21.9219 12.7641H24.1366C24.2288 12.3937 24.2795 12.1878 24.2897 12.1464C24.4903 12.3948 24.7108 12.5814 24.9529 12.705C25.1939 12.8292 25.5545 12.8911 25.8338 12.8911C26.2225 12.8911 26.5579 12.7867 26.8409 12.5775C27.1234 12.3688 27.3035 12.1215 27.38 11.8372C27.4566 11.5524 27.4949 11.1196 27.4949 10.5377C27.4949 10.2655 27.4949 8.08936 27.4949 7.8172C27.4949 7.23203 27.4819 6.85001 27.4566 6.6706C27.4312 6.49118 27.3558 6.30846 27.2302 6.12131C27.1045 5.93417 26.9218 5.78898 26.6824 5.68519C26.443 5.58141 26.1605 5.52952 25.8349 5.52952C25.5518 5.52952 25.1895 5.58748 24.948 5.70175C24.707 5.81603 24.4881 5.98937 24.2919 6.22178C24.2919 6.01145 24.2919 4.96035 24.2919 3.06738H21.9219V12.7641Z"
                                                      fill="black"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_6867_3112">
                                                      <rect width="31" height="16" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                              </div>
                                              <div
                                                className="flex flex-row items-center gap-2-1 font-normal text-xs text-gray-700"
                                                style={{
                                                  flex: 'none',
                                                  order: 1,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                Upgrade to Add
                                              </div>
                                            </div>
                                           
                                          </>
                                        ) : imdbKit?.link_url == undefined ||
                                          imdbKit.link_url.trim() == '' ? (
                                          <>
                                            <div
                                              className="flex flex-row items-center gap-1 cursor-pointer"
                                              style={{
                                                padding: '3px 8px 3px 3px',
                                                minHeight: '1.5rem',
                                                // border: '1px dashed #D1D5DB',
                                                border: imdbUrl.indexOf("pro.imdb") >= 0 ? '1px solid #01AEDA' : '1px solid #F6C700',

                                                borderRadius: '0.5rem',
                                                // flex: 'none',
                                                order: 2,
                                                flexGrow: 0,
                                              }}
                                              onClick={() => {
                                                setaddImdbShow(true);
                                              }}
                                            >
                                              <div
                                                className="flex flex-row items-start gap-2-1 "
                                                style={{
                                                  padding: '4px 6px',
                                                  background: imdbUrl.indexOf("pro.imdb") >= 0 ?'#F3F4F6':'#F6C700',
                                                  // background: '#F6C700', // yellow
                                                  // opacity: '0.4',
                                                  borderRadius: '5px 0px 0px 5px',
                                                  flex: 'none',
                                                  order: 0,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                {imdbUrl.indexOf("pro.imdb") < 0 ?(<svg
                                                  width="31"
                                                  height="16"
                                                  viewBox="0 0 31 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <g clip-path="url(#clip0_6867_3112)">
                                                    <path
                                                      d="M31 1.37515C30.9159 0.670738 30.4053 0.109305 29.7551 0C26.9053 0 4.1071 0 1.25725 0C0.545061 0.119794 0 0.7817 0 1.57941C0 2.86182 0 13.1189 0 14.4007C0 15.284 0.666904 16 1.49016 16C4.2931 16 26.7193 16 29.5222 16C30.2803 16 30.9062 15.3922 31 14.6055C31 11.9596 31 2.69786 31 1.37515Z"
                                                      fill="#F6C700"
                                                    />
                                                    <path
                                                      d="M3.74219 3.21484H6.20224V12.9116H3.74219V3.21484Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M10.8443 7.68147C10.6329 6.20364 10.5154 5.38219 10.4922 5.21823C10.3892 4.42715 10.2911 3.73875 10.1973 3.15137C9.98435 3.15137 8.92173 3.15137 7.00781 3.15137V12.8481H9.16272L9.17026 6.44544L10.0771 12.8481H11.612L12.4719 6.30301L12.48 12.8481H14.6279V3.15137H11.4141L10.8443 7.68147Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M18.6922 5.16855C18.7191 5.29221 18.7332 5.57265 18.7332 6.01097C18.7332 6.38692 18.7332 9.39448 18.7332 9.77042C18.7332 10.4158 18.6922 10.811 18.6108 10.9568C18.5288 11.1025 18.311 11.1748 17.9579 11.1748C17.9579 10.5383 17.9579 5.44623 17.9579 4.80972C18.2258 4.80972 18.4086 4.83898 18.5057 4.89639C18.6027 4.95436 18.6652 5.04489 18.6922 5.16855ZM19.8033 12.7493C20.0961 12.6836 20.3419 12.5676 20.5414 12.4026C20.7403 12.237 20.88 12.0079 20.9598 11.7147C21.0401 11.4221 21.0875 10.8408 21.0875 9.97137C21.0875 9.6313 21.0875 6.90695 21.0875 6.56633C21.0875 5.64883 21.0525 5.03385 20.9981 4.72139C20.9431 4.40838 20.8067 4.12408 20.5883 3.86903C20.3694 3.61398 20.0503 3.4307 19.6308 3.31919C19.2108 3.20768 18.5261 3.15137 17.3352 3.15137C17.2128 3.15137 16.6014 3.15137 15.5 3.15137V12.8481H18.4803C19.1672 12.826 19.6082 12.7934 19.8033 12.7493Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M25.0531 11.3006C25.0079 11.4237 24.8095 11.4861 24.6596 11.4861C24.5129 11.4861 24.4154 11.4265 24.3658 11.3067C24.3162 11.1875 24.2919 10.9153 24.2919 10.4891C24.2919 10.233 24.2919 8.18266 24.2919 7.92651C24.2919 7.48487 24.3135 7.2094 24.3571 7.09954C24.4003 6.99079 24.4951 6.93558 24.6418 6.93558C24.7917 6.93558 24.9928 6.99796 25.0445 7.12328C25.0957 7.24859 25.1216 7.51634 25.1216 7.92651C25.1216 8.09212 25.1216 8.92019 25.1216 10.4113C25.106 10.9219 25.0833 11.2184 25.0531 11.3006ZM21.9219 12.7641H24.1366C24.2288 12.3937 24.2795 12.1878 24.2897 12.1464C24.4903 12.3948 24.7108 12.5814 24.9529 12.705C25.1939 12.8292 25.5545 12.8911 25.8338 12.8911C26.2225 12.8911 26.5579 12.7867 26.8409 12.5775C27.1234 12.3688 27.3035 12.1215 27.38 11.8372C27.4566 11.5524 27.4949 11.1196 27.4949 10.5377C27.4949 10.2655 27.4949 8.08936 27.4949 7.8172C27.4949 7.23203 27.4819 6.85001 27.4566 6.6706C27.4312 6.49118 27.3558 6.30846 27.2302 6.12131C27.1045 5.93417 26.9218 5.78898 26.6824 5.68519C26.443 5.58141 26.1605 5.52952 25.8349 5.52952C25.5518 5.52952 25.1895 5.58748 24.948 5.70175C24.707 5.81603 24.4881 5.98937 24.2919 6.22178C24.2919 6.01145 24.2919 4.96035 24.2919 3.06738H21.9219V12.7641Z"
                                                      fill="black"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_6867_3112">
                                                      <rect width="31" height="16" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>) :
                                                  (<svg width="52" height="29" viewBox="0 0 52 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H51.6108V29H7.99999C5.19974 29 3.79961 29 2.73005 28.455C1.78924 27.9757 1.02433 27.2108 0.544967 26.27C0 25.2004 0 23.8003 0 21V8Z" fill="#F3F4F6" />
                                                    <g clip-path="url(#clip0_7824_41673)">
                                                      <path d="M8.46129 9.65332H6V19.1205H8.46129V9.65332Z" fill="black" />
                                                      <path d="M13.6735 9.65332L13.1373 14.0749L12.7857 11.6751C12.6802 10.9015 12.5835 10.2335 12.4868 9.66211H9.30469V19.1205H11.4583V12.8706L12.3725 19.1205H13.9108L14.7723 12.7211V19.1117H16.9171V9.65332H13.6735Z" fill="black" />
                                                      <path d="M20.7573 11.3594C20.854 11.4122 20.9243 11.5177 20.9419 11.6319C20.9858 11.9044 20.9946 12.1769 20.9858 12.4494V16.115C21.0122 16.5018 20.977 16.8973 20.8628 17.2753C20.7749 17.4248 20.5639 17.4863 20.2123 17.4863V11.2715C20.3969 11.2627 20.5903 11.2891 20.7573 11.3594ZM20.7573 19.1213C21.1968 19.1389 21.6451 19.1037 22.0758 19.0246C22.3571 18.9807 22.6208 18.8576 22.8406 18.6906C23.0428 18.5148 23.1922 18.2862 23.2625 18.0225C23.368 17.4599 23.4032 16.8886 23.3856 16.3172V12.9856C23.3856 12.3879 23.3328 11.7814 23.2449 11.1924C23.201 10.8847 23.0691 10.5947 22.867 10.3573C22.612 10.0936 22.278 9.90023 21.9176 9.82112C21.1616 9.68047 20.3881 9.62773 19.6145 9.66289H17.7422V19.1213H20.7573Z" fill="black" />
                                                      <path d="M27.3706 16.8174C27.3794 17.1075 27.3618 17.4064 27.309 17.6877C27.2651 17.802 27.0629 17.8635 26.9135 17.8635C26.7904 17.8811 26.6674 17.802 26.6234 17.6877C26.5531 17.4416 26.5267 17.1778 26.5443 16.9229V14.3913C26.5267 14.1364 26.5531 13.8727 26.6146 13.6266C26.6586 13.5123 26.7816 13.4507 26.8959 13.4683C27.0453 13.4683 27.2475 13.5299 27.2915 13.6529C27.3618 13.8991 27.3882 14.1628 27.3706 14.4177V16.8174ZM24.1797 9.65332V19.1205H26.3861L26.5355 18.514C26.7113 18.7425 26.9399 18.9271 27.1948 19.059C27.4761 19.182 27.7749 19.2436 28.0738 19.2436C28.4342 19.2524 28.7858 19.1469 29.0759 18.9359C29.3396 18.7689 29.533 18.514 29.6209 18.2151C29.7264 17.802 29.7703 17.3712 29.7703 16.9405V14.2595C29.7791 13.8815 29.7616 13.5123 29.7352 13.1431C29.7 12.9497 29.6209 12.7739 29.5066 12.6157C29.3748 12.4223 29.1814 12.2728 28.9616 12.1849C28.6891 12.0795 28.399 12.0267 28.109 12.0355C27.8101 12.0355 27.5112 12.0882 27.2299 12.2025C26.975 12.3256 26.7553 12.4926 26.5707 12.7124V9.6709H24.1797V9.65332Z" fill="black" />
                                                      <path d="M30.6484 9.6537H33.0922C33.6108 9.63612 34.1206 9.68887 34.6305 9.80314C34.9381 9.88225 35.2106 10.0317 35.4392 10.2514C35.6238 10.4536 35.7468 10.6998 35.7996 10.9635C35.8699 11.3854 35.9051 11.8161 35.8875 12.2556V13.0644C35.9138 13.5039 35.8523 13.9522 35.7029 14.3653C35.5622 14.6554 35.3249 14.8752 35.026 14.9982C34.6129 15.1565 34.1734 15.2268 33.7338 15.2092H33.0834V18.9715H30.6484V9.6537ZM33.0746 11.2448V13.6181H33.2592C33.4262 13.6357 33.602 13.5742 33.7163 13.4599C33.8217 13.249 33.8745 13.0116 33.8481 12.7743V12.0095C33.8745 11.7898 33.8217 11.57 33.6987 11.3854C33.5141 11.2711 33.2943 11.2184 33.0746 11.2448Z" fill="#01AEDA" />
                                                      <path d="M38.22 12.2295L38.1321 13.1173C38.431 12.4844 39.4946 12.2734 40.066 12.2383L39.4419 14.4886C39.1606 14.471 38.8705 14.5238 38.6156 14.638C38.4486 14.7259 38.3343 14.8754 38.2903 15.06C38.2288 15.4731 38.2024 15.8951 38.2112 16.317V18.9805H36.1719V12.2295H38.22Z" fill="#01AEDA" />
                                                      <path d="M45.5982 16.3343C45.6158 16.809 45.5718 17.2837 45.4927 17.7496C45.4048 18.066 45.2466 18.3561 45.018 18.5934C44.7631 18.8659 44.4379 19.0593 44.0863 19.1648C43.6643 19.2967 43.2248 19.3582 42.7853 19.3494C42.3106 19.3582 41.8359 19.3054 41.3788 19.1912C41.0536 19.1121 40.7635 18.945 40.5174 18.7165C40.3064 18.4967 40.157 18.233 40.0691 17.9517C39.9548 17.4946 39.9021 17.0288 39.9108 16.5629V14.7521C39.8845 14.2334 39.9724 13.706 40.157 13.2137C40.3328 12.8182 40.6492 12.5017 41.036 12.3171C41.5458 12.0622 42.1084 11.9391 42.6798 11.9567C43.1633 11.9479 43.6555 12.0183 44.1126 12.1765C44.4642 12.282 44.7807 12.4666 45.0444 12.7215C45.2466 12.9237 45.4048 13.1698 45.4927 13.4423C45.5806 13.8203 45.6246 14.1983 45.607 14.585V16.3343H45.5982ZM43.1193 14.0488C43.1369 13.8203 43.1105 13.5829 43.049 13.3544C42.9787 13.2665 42.8732 13.2137 42.7589 13.2137C42.6446 13.2137 42.5392 13.2665 42.4688 13.3544C42.3985 13.5742 42.3721 13.8115 42.3897 14.0488V17.2661C42.3721 17.4859 42.3985 17.7144 42.4688 17.9254C42.5216 18.0309 42.6358 18.0924 42.7501 18.0748C42.8644 18.0924 42.9875 18.0396 43.049 17.9342C43.1105 17.7408 43.1369 17.5298 43.1193 17.3276V14.0488Z" fill="#01AEDA" />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_7824_41673">
                                                        <rect width="39.6108" height="16" fill="white" transform="translate(6 6.5)" />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                  )}
                                              </div>
                                              {addImdbShow ? (
                                                <div className='flex flex-row gap-1 pr-1'>
                                                  <input
                                                    // onBlur={() => {
                                                    //   console.log('onblur');
                                                    //   // setaddImdbShow(false);
                                                    // }}
                                                    value={imdbUrl}
                                                    onChange={(e) => {
                                                      setimdbUrl(e.target.value);
                                                    }}
                                                    onKeyDown={handleKeyDown}
                                                    type="text"
                                                    name="imdblink"
                                                    id="imdblink"
                                                    placeholder="IMDB Url"
                                                    className="w-full flex-grow bg-white shadow-sm border border-gray-300 px-1 py-1 border-0 rounded-lg focus:shadow-outline text-left "
                                                  />
                                                  <div className='flex flex-col items-center text-blue-500 sm:flex-row gap-2'>
                                                    <div
                                                      id={'sbpd_cancel_imdb_id'}
                                                      // variant="secondary"
                                                      // btn_size="small"
                                                      // icon_position="hor"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        console.log('cancel imdburl edit');
                                                        setaddImdbShow(false);
                                                      }}
                                                    >
                                                      <XIcon className='w-3 h-3'/>
                                                    </div>
                                                    <div
                                                      id={'sbpd_save_imdb_id'}
                                                      // variant="primary"
                                                      // btn_size="small"
                                                      // icon_position="hor"
                                                      onClick={async () => {
                                                        await saveSocialKit();
                                                      }}
                                                    >
                                                      <CheckIcon className='w-3 h-3'/>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className="flex flex-row items-center gap-2-1 font-normal text-xs text-gray-700"
                                                  style={{
                                                    flex: 'none',
                                                    order: 1,
                                                    flexGrow: 0,
                                                  }}
                                                >
                                                  <div className="flex items-center">
                                                    Add IMDb Profile
                                                  </div>
                                                  <div className="flex items-center">
                                                    <PencilLineIcon className="h-3 w-3 text-blue-500" />
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <a
                                            href={imdbKit.link_url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flex items-center gap-1"
                                          >
                                            <div
                                              className="flex flex-row items-center gap-1 ring-0-3-6-2-25 hover:shadow-ring-0-3-6-2-25  active:bg-gray-100"
                                              style={{
                                                padding: '3px 8px 3px 3px',
                                                minHeight: '1.5rem',
                                                // border: '1px dashed #D1D5DB',
                                                // border: '1px solid #F6C700',
                                                border: imdbKit.link_url.indexOf("pro.imdb") >= 0 ? '1px solid #01AEDA' : '1px solid #F6C700', borderRadius: '0.5rem',
                                                flex: 'none',
                                                order: 2,
                                                flexGrow: 0,
                                              }}
                                            >
                                              <div
                                                className="flex flex-row items-start gap-2-1 "
                                                style={{
                                                  padding: '4px 6px',
                                                  background: imdbKit.link_url.indexOf("pro.imdb") >= 0 ?'#F3F4F6':'#F6C700',
                                                  // opacity: '0.4',
                                                  borderRadius: '5px 0px 0px 5px',
                                                  flex: 'none',
                                                  order: 0,
                                                  flexGrow: 0,
                                                }}
                                              >
                                              {imdbKit.link_url.indexOf("pro.imdb") < 0 ?  (<svg
                                                  width="31"
                                                  height="16"
                                                  viewBox="0 0 31 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <g clip-path="url(#clip0_6867_3112)">
                                                    <path
                                                      d="M31 1.37515C30.9159 0.670738 30.4053 0.109305 29.7551 0C26.9053 0 4.1071 0 1.25725 0C0.545061 0.119794 0 0.7817 0 1.57941C0 2.86182 0 13.1189 0 14.4007C0 15.284 0.666904 16 1.49016 16C4.2931 16 26.7193 16 29.5222 16C30.2803 16 30.9062 15.3922 31 14.6055C31 11.9596 31 2.69786 31 1.37515Z"
                                                      fill="#F6C700"
                                                    />
                                                    <path
                                                      d="M3.74219 3.21484H6.20224V12.9116H3.74219V3.21484Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M10.8443 7.68147C10.6329 6.20364 10.5154 5.38219 10.4922 5.21823C10.3892 4.42715 10.2911 3.73875 10.1973 3.15137C9.98435 3.15137 8.92173 3.15137 7.00781 3.15137V12.8481H9.16272L9.17026 6.44544L10.0771 12.8481H11.612L12.4719 6.30301L12.48 12.8481H14.6279V3.15137H11.4141L10.8443 7.68147Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M18.6922 5.16855C18.7191 5.29221 18.7332 5.57265 18.7332 6.01097C18.7332 6.38692 18.7332 9.39448 18.7332 9.77042C18.7332 10.4158 18.6922 10.811 18.6108 10.9568C18.5288 11.1025 18.311 11.1748 17.9579 11.1748C17.9579 10.5383 17.9579 5.44623 17.9579 4.80972C18.2258 4.80972 18.4086 4.83898 18.5057 4.89639C18.6027 4.95436 18.6652 5.04489 18.6922 5.16855ZM19.8033 12.7493C20.0961 12.6836 20.3419 12.5676 20.5414 12.4026C20.7403 12.237 20.88 12.0079 20.9598 11.7147C21.0401 11.4221 21.0875 10.8408 21.0875 9.97137C21.0875 9.6313 21.0875 6.90695 21.0875 6.56633C21.0875 5.64883 21.0525 5.03385 20.9981 4.72139C20.9431 4.40838 20.8067 4.12408 20.5883 3.86903C20.3694 3.61398 20.0503 3.4307 19.6308 3.31919C19.2108 3.20768 18.5261 3.15137 17.3352 3.15137C17.2128 3.15137 16.6014 3.15137 15.5 3.15137V12.8481H18.4803C19.1672 12.826 19.6082 12.7934 19.8033 12.7493Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M25.0531 11.3006C25.0079 11.4237 24.8095 11.4861 24.6596 11.4861C24.5129 11.4861 24.4154 11.4265 24.3658 11.3067C24.3162 11.1875 24.2919 10.9153 24.2919 10.4891C24.2919 10.233 24.2919 8.18266 24.2919 7.92651C24.2919 7.48487 24.3135 7.2094 24.3571 7.09954C24.4003 6.99079 24.4951 6.93558 24.6418 6.93558C24.7917 6.93558 24.9928 6.99796 25.0445 7.12328C25.0957 7.24859 25.1216 7.51634 25.1216 7.92651C25.1216 8.09212 25.1216 8.92019 25.1216 10.4113C25.106 10.9219 25.0833 11.2184 25.0531 11.3006ZM21.9219 12.7641H24.1366C24.2288 12.3937 24.2795 12.1878 24.2897 12.1464C24.4903 12.3948 24.7108 12.5814 24.9529 12.705C25.1939 12.8292 25.5545 12.8911 25.8338 12.8911C26.2225 12.8911 26.5579 12.7867 26.8409 12.5775C27.1234 12.3688 27.3035 12.1215 27.38 11.8372C27.4566 11.5524 27.4949 11.1196 27.4949 10.5377C27.4949 10.2655 27.4949 8.08936 27.4949 7.8172C27.4949 7.23203 27.4819 6.85001 27.4566 6.6706C27.4312 6.49118 27.3558 6.30846 27.2302 6.12131C27.1045 5.93417 26.9218 5.78898 26.6824 5.68519C26.443 5.58141 26.1605 5.52952 25.8349 5.52952C25.5518 5.52952 25.1895 5.58748 24.948 5.70175C24.707 5.81603 24.4881 5.98937 24.2919 6.22178C24.2919 6.01145 24.2919 4.96035 24.2919 3.06738H21.9219V12.7641Z"
                                                      fill="black"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_6867_3112">
                                                      <rect width="31" height="16" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>) :
                                                  (<svg width="52" height="29" viewBox="0 0 52 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H51.6108V29H7.99999C5.19974 29 3.79961 29 2.73005 28.455C1.78924 27.9757 1.02433 27.2108 0.544967 26.27C0 25.2004 0 23.8003 0 21V8Z" fill="#F3F4F6" />
                                                    <g clip-path="url(#clip0_7824_41673)">
                                                      <path d="M8.46129 9.65332H6V19.1205H8.46129V9.65332Z" fill="black" />
                                                      <path d="M13.6735 9.65332L13.1373 14.0749L12.7857 11.6751C12.6802 10.9015 12.5835 10.2335 12.4868 9.66211H9.30469V19.1205H11.4583V12.8706L12.3725 19.1205H13.9108L14.7723 12.7211V19.1117H16.9171V9.65332H13.6735Z" fill="black" />
                                                      <path d="M20.7573 11.3594C20.854 11.4122 20.9243 11.5177 20.9419 11.6319C20.9858 11.9044 20.9946 12.1769 20.9858 12.4494V16.115C21.0122 16.5018 20.977 16.8973 20.8628 17.2753C20.7749 17.4248 20.5639 17.4863 20.2123 17.4863V11.2715C20.3969 11.2627 20.5903 11.2891 20.7573 11.3594ZM20.7573 19.1213C21.1968 19.1389 21.6451 19.1037 22.0758 19.0246C22.3571 18.9807 22.6208 18.8576 22.8406 18.6906C23.0428 18.5148 23.1922 18.2862 23.2625 18.0225C23.368 17.4599 23.4032 16.8886 23.3856 16.3172V12.9856C23.3856 12.3879 23.3328 11.7814 23.2449 11.1924C23.201 10.8847 23.0691 10.5947 22.867 10.3573C22.612 10.0936 22.278 9.90023 21.9176 9.82112C21.1616 9.68047 20.3881 9.62773 19.6145 9.66289H17.7422V19.1213H20.7573Z" fill="black" />
                                                      <path d="M27.3706 16.8174C27.3794 17.1075 27.3618 17.4064 27.309 17.6877C27.2651 17.802 27.0629 17.8635 26.9135 17.8635C26.7904 17.8811 26.6674 17.802 26.6234 17.6877C26.5531 17.4416 26.5267 17.1778 26.5443 16.9229V14.3913C26.5267 14.1364 26.5531 13.8727 26.6146 13.6266C26.6586 13.5123 26.7816 13.4507 26.8959 13.4683C27.0453 13.4683 27.2475 13.5299 27.2915 13.6529C27.3618 13.8991 27.3882 14.1628 27.3706 14.4177V16.8174ZM24.1797 9.65332V19.1205H26.3861L26.5355 18.514C26.7113 18.7425 26.9399 18.9271 27.1948 19.059C27.4761 19.182 27.7749 19.2436 28.0738 19.2436C28.4342 19.2524 28.7858 19.1469 29.0759 18.9359C29.3396 18.7689 29.533 18.514 29.6209 18.2151C29.7264 17.802 29.7703 17.3712 29.7703 16.9405V14.2595C29.7791 13.8815 29.7616 13.5123 29.7352 13.1431C29.7 12.9497 29.6209 12.7739 29.5066 12.6157C29.3748 12.4223 29.1814 12.2728 28.9616 12.1849C28.6891 12.0795 28.399 12.0267 28.109 12.0355C27.8101 12.0355 27.5112 12.0882 27.2299 12.2025C26.975 12.3256 26.7553 12.4926 26.5707 12.7124V9.6709H24.1797V9.65332Z" fill="black" />
                                                      <path d="M30.6484 9.6537H33.0922C33.6108 9.63612 34.1206 9.68887 34.6305 9.80314C34.9381 9.88225 35.2106 10.0317 35.4392 10.2514C35.6238 10.4536 35.7468 10.6998 35.7996 10.9635C35.8699 11.3854 35.9051 11.8161 35.8875 12.2556V13.0644C35.9138 13.5039 35.8523 13.9522 35.7029 14.3653C35.5622 14.6554 35.3249 14.8752 35.026 14.9982C34.6129 15.1565 34.1734 15.2268 33.7338 15.2092H33.0834V18.9715H30.6484V9.6537ZM33.0746 11.2448V13.6181H33.2592C33.4262 13.6357 33.602 13.5742 33.7163 13.4599C33.8217 13.249 33.8745 13.0116 33.8481 12.7743V12.0095C33.8745 11.7898 33.8217 11.57 33.6987 11.3854C33.5141 11.2711 33.2943 11.2184 33.0746 11.2448Z" fill="#01AEDA" />
                                                      <path d="M38.22 12.2295L38.1321 13.1173C38.431 12.4844 39.4946 12.2734 40.066 12.2383L39.4419 14.4886C39.1606 14.471 38.8705 14.5238 38.6156 14.638C38.4486 14.7259 38.3343 14.8754 38.2903 15.06C38.2288 15.4731 38.2024 15.8951 38.2112 16.317V18.9805H36.1719V12.2295H38.22Z" fill="#01AEDA" />
                                                      <path d="M45.5982 16.3343C45.6158 16.809 45.5718 17.2837 45.4927 17.7496C45.4048 18.066 45.2466 18.3561 45.018 18.5934C44.7631 18.8659 44.4379 19.0593 44.0863 19.1648C43.6643 19.2967 43.2248 19.3582 42.7853 19.3494C42.3106 19.3582 41.8359 19.3054 41.3788 19.1912C41.0536 19.1121 40.7635 18.945 40.5174 18.7165C40.3064 18.4967 40.157 18.233 40.0691 17.9517C39.9548 17.4946 39.9021 17.0288 39.9108 16.5629V14.7521C39.8845 14.2334 39.9724 13.706 40.157 13.2137C40.3328 12.8182 40.6492 12.5017 41.036 12.3171C41.5458 12.0622 42.1084 11.9391 42.6798 11.9567C43.1633 11.9479 43.6555 12.0183 44.1126 12.1765C44.4642 12.282 44.7807 12.4666 45.0444 12.7215C45.2466 12.9237 45.4048 13.1698 45.4927 13.4423C45.5806 13.8203 45.6246 14.1983 45.607 14.585V16.3343H45.5982ZM43.1193 14.0488C43.1369 13.8203 43.1105 13.5829 43.049 13.3544C42.9787 13.2665 42.8732 13.2137 42.7589 13.2137C42.6446 13.2137 42.5392 13.2665 42.4688 13.3544C42.3985 13.5742 42.3721 13.8115 42.3897 14.0488V17.2661C42.3721 17.4859 42.3985 17.7144 42.4688 17.9254C42.5216 18.0309 42.6358 18.0924 42.7501 18.0748C42.8644 18.0924 42.9875 18.0396 43.049 17.9342C43.1105 17.7408 43.1369 17.5298 43.1193 17.3276V14.0488Z" fill="#01AEDA" />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_7824_41673">
                                                        <rect width="39.6108" height="16" fill="white" transform="translate(6 6.5)" />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                  )}
                                              </div>
                                              <div
                                                className="flex flex-row items-center gap-2-1 font-normal text-xs text-gray-700"
                                                style={{
                                                  flex: 'none',
                                                  order: 1,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                <span className="text-gray-900">View Profile</span>
                                                <span className="text-13 text-blue-500">
                                                  <ExternalLinkIcon className="w-3 h-3" />
                                                </span>
                                              </div>
                                            </div>
                                            {/* <span className="text-gray-900">View IMDb</span>
                                                  <span className="text-13 text-blue-500">
                                                    <ExternalLinkIcon className="w-3 h-3" />
                                                  </span> */}
                                          </a>
                                        )}
                                      </div>
                                    )}
                                    {fromScreen !== fromRole.SB_PERFORMER &&
                                      imdbKit?.link_url &&
                                      imdbKit.link_url.trim() !== '' && (
                                        <div className="flex items-center text-sm leading-6">
                                          <span className="w-16 text-11 font-semibold text-gray-500">
                                            IMDb
                                          </span>
                                          <a
                                            href={imdbKit.link_url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flex items-center gap-1"
                                          >
                                            <div
                                              className="flex flex-row items-center gap-1 ring-0-3-6-2-25 hover:shadow-ring-0-3-6-2-25 active:bg-gray-100"
                                              style={{
                                                padding: '3px 8px 3px 3px',
                                                minHeight: '1.5rem',
                                                // border: '1px dashed #D1D5DB',
                                                border: `1px solid ${imdbKit.link_url.toLowerCase().includes('pro') ? '#01AEDA' : '#F6C700'}`,
                                                borderRadius: '0.5rem',
                                                flex: 'none',
                                                order: 2,
                                                flexGrow: 0,
                                              }}
                                            >
                                              <div
                                                className="flex flex-row items-start gap-2-1 "
                                                style={{
                                                  padding: '4px 6px',
                                                  background: imdbKit.link_url.toLowerCase().includes('pro') ? '#ffffff' : '#F6C700',
                                                  // opacity: '0.4',
                                                  borderRadius: '5px 0px 0px 5px',
                                                  flex: 'none',
                                                  order: 0,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                {imdbKit.link_url.toLowerCase().includes('pro') ? (
                                                  <div className="flex items-center gap-0.5 font-semibold text-sm">
                                                    <span className="text-black">IMDB</span>
                                                    <span style={{ color: '#01AEDA' }}>Pro</span>
                                                  </div>
                                                ) : (
                                                  <svg
                                                    width="31"
                                                    height="16"
                                                    viewBox="0 0 31 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <g clip-path="url(#clip0_6867_3112)">
                                                      <path
                                                        d="M31 1.37515C30.9159 0.670738 30.4053 0.109305 29.7551 0C26.9053 0 4.1071 0 1.25725 0C0.545061 0.119794 0 0.7817 0 1.57941C0 2.86182 0 13.1189 0 14.4007C0 15.284 0.666904 16 1.49016 16C4.2931 16 26.7193 16 29.5222 16C30.2803 16 30.9062 15.3922 31 14.6055C31 11.9596 31 2.69786 31 1.37515Z"
                                                        fill="#F6C700"
                                                      />
                                                      <path
                                                        d="M3.74219 3.21484H6.20224V12.9116H3.74219V3.21484Z"
                                                        fill="black"
                                                      />
                                                      <path
                                                        d="M10.8443 7.68147C10.6329 6.20364 10.5154 5.38219 10.4922 5.21823C10.3892 4.42715 10.2911 3.73875 10.1973 3.15137C9.98435 3.15137 8.92173 3.15137 7.00781 3.15137V12.8481H9.16272L9.17026 6.44544L10.0771 12.8481H11.612L12.4719 6.30301L12.48 12.8481H14.6279V3.15137H11.4141L10.8443 7.68147Z"
                                                        fill="black"
                                                      />
                                                      <path
                                                        d="M18.6922 5.16855C18.7191 5.29221 18.7332 5.57265 18.7332 6.01097C18.7332 6.38692 18.7332 9.39448 18.7332 9.77042C18.7332 10.4158 18.6922 10.811 18.6108 10.9568C18.5288 11.1025 18.311 11.1748 17.9579 11.1748C17.9579 10.5383 17.9579 5.44623 17.9579 4.80972C18.2258 4.80972 18.4086 4.83898 18.5057 4.89639C18.6027 4.95436 18.6652 5.04489 18.6922 5.16855ZM19.8033 12.7493C20.0961 12.6836 20.3419 12.5676 20.5414 12.4026C20.7403 12.237 20.88 12.0079 20.9598 11.7147C21.0401 11.4221 21.0875 10.8408 21.0875 9.97137C21.0875 9.6313 21.0875 6.90695 21.0875 6.56633C21.0875 5.64883 21.0525 5.03385 20.9981 4.72139C20.9431 4.40838 20.8067 4.12408 20.5883 3.86903C20.3694 3.61398 20.0503 3.4307 19.6308 3.31919C19.2108 3.20768 18.5261 3.15137 17.3352 3.15137C17.2128 3.15137 16.6014 3.15137 15.5 3.15137V12.8481H18.4803C19.1672 12.826 19.6082 12.7934 19.8033 12.7493Z"
                                                        fill="black"
                                                      />
                                                      <path
                                                        d="M25.0531 11.3006C25.0079 11.4237 24.8095 11.4861 24.6596 11.4861C24.5129 11.4861 24.4154 11.4265 24.3658 11.3067C24.3162 11.1875 24.2919 10.9153 24.2919 10.4891C24.2919 10.233 24.2919 8.18266 24.2919 7.92651C24.2919 7.48487 24.3135 7.2094 24.3571 7.09954C24.4003 6.99079 24.4951 6.93558 24.6418 6.93558C24.7917 6.93558 24.9928 6.99796 25.0445 7.12328C25.0957 7.24859 25.1216 7.51634 25.1216 7.92651C25.1216 8.09212 25.1216 8.92019 25.1216 10.4113C25.106 10.9219 25.0833 11.2184 25.0531 11.3006ZM21.9219 12.7641H24.1366C24.2288 12.3937 24.2795 12.1878 24.2897 12.1464C24.4903 12.3948 24.7108 12.5814 24.9529 12.705C25.1939 12.8292 25.5545 12.8911 25.8338 12.8911C26.2225 12.8911 26.5579 12.7867 26.8409 12.5775C27.1234 12.3688 27.3035 12.1215 27.38 11.8372C27.4566 11.5524 27.4949 11.1196 27.4949 10.5377C27.4949 10.2655 27.4949 8.08936 27.4949 7.8172C27.4949 7.23203 27.4819 6.85001 27.4566 6.6706C27.4312 6.49118 27.3558 6.30846 27.2302 6.12131C27.1045 5.93417 26.9218 5.78898 26.6824 5.68519C26.443 5.58141 26.1605 5.52952 25.8349 5.52952C25.5518 5.52952 25.1895 5.58748 24.948 5.70175C24.707 5.81603 24.4881 5.98937 24.2919 6.22178C24.2919 6.01145 24.2919 4.96035 24.2919 3.06738H21.9219V12.7641Z"
                                                        fill="black"
                                                      />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_6867_3112">
                                                        <rect width="31" height="16" fill="white" />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                )}
                                              </div>
                                              <div
                                                className="flex flex-row items-center gap-2-1 font-normal text-xs text-gray-700"
                                                style={{
                                                  flex: 'none',
                                                  order: 1,
                                                  flexGrow: 0,
                                                }}
                                              >
                                                <span className="text-gray-900">View Profile</span>
                                                <span className="text-13 text-blue-500">
                                                  <ExternalLinkIcon className="w-3 h-3" />
                                                </span>
                                              </div>
                                            </div>
                                            {/* <span className="text-gray-900">View IMDb</span>
                                                  <span className="text-13 text-blue-500">
                                                  </span> */}
                                          </a>
                                        </div>
                                      )}
                                  </div>
                                </>
                              )}
                              {tabSelected == 2 && (
                                <>
                                  {/* Notes */}
                                  {/* Coordinator Notes  */}
                                  {noteTexts.length > 0 && (
                                    <div className="flex w-full">
                                      <div className="flex flex-col w-full scrollable-content overflow-y-auto h-full gap-4">
                                        {noteTextsCoordinate.length > 0 && (
                                          <div className="flex flex-col w-full border-b border-gray-200 pb-4">
                                            <div
                                              className="py-1 pt-4 text-sm font-semibold text-gray-900 flex items-center w-full"
                                              style={{
                                                fontSize: '0.6875rem', // 11px
                                              }}
                                            >
                                              Coordinator Notes <span className="ml-1"></span>{' '}
                                              <Pin className="w-3 h-3 opacity-100" />
                                            </div>
                                            <div className="flex flex-col gap-4 w-full">
                                              {noteTextsCoordinate.map((noteData, index) =>
                                                renderNote(
                                                  noteData,
                                                  index,
                                                  noteTextsCoordinate.length
                                                )
                                              )}
                                            </div>
                                          </div>
                                        )}
                                        {/* Other Notes */}
                                        {noteTextsOther.length > 0 && (
                                          <div className="flex flex-col w-full">
                                            <div
                                              className="py-1 font-semibold text-gray-900 w-full"
                                              style={{
                                                fontSize: '0.6875rem', // 11px
                                              }}
                                            >
                                              Other Notes
                                            </div>
                                            <div className="flex flex-col gap-4 w-full">
                                              {noteTextsOther.map((noteData, index) =>
                                                noteData.note_role === 'selector' ||
                                                  noteData.note_role === null
                                                  ? renderNote(
                                                    noteData,
                                                    index,
                                                    noteTextsOther.length
                                                  )
                                                  : null
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {/* Coordinator Notes  */}
                                </>
                              )}
                              {tabSelected == 4 && (
                                <div className="flex flex-col w-full gap-6 p-1">
                                  <div className="flex flex-col gap-3">
                                    <span className="text-11 font-semibold text-gray-500 uppercase tracking-wider">
                                      Professional Overview
                                    </span>
                                    <div className="text-13 text-gray-900 leading-relaxed whitespace-pre-line">
                                      {generalInformation || (
                                        <span className="text-gray-400 italic">No professional overview available.</span>
                                      )}
                                    </div>
                                  </div>

                                  <div className="flex flex-col gap-3">
                                    <span className="text-11 font-semibold text-gray-500 uppercase tracking-wider">
                                      Specialty Skills
                                    </span>
                                    <div className="flex flex-wrap gap-2">
                                      {skills.length > 0 ? (
                                        skills.map((skill) => (
                                          <div
                                            key={skill.id}
                                            className="px-4 py-1.5 bg-[#E9EEF6] border border-[#8CA2C280] rounded-full text-13 font-medium text-[#0D1621]"
                                          >
                                            {skill.name}
                                          </div>
                                        ))
                                      ) : (
                                        <span className="text-gray-400 text-13 italic">No specialty skills available.</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              {tabSelected == 3 && (
                                <>{renderMobileMedia()}</>
                              )}
                            </div>
                          </div>
                        )}
                        {/* PreferredByRecipient  */}
                        {(fromScreen === fromRole.SB_CREATOR ||
                          fromScreen === fromRole.RECIPIENT ||
                          fromScreen === fromRole.SB_EXTERNAL_RECIPIENT) && (
                            <div
                              className="flex flex-col gap-4"
                              style={{
                                display: isPreferredBy > 0 ? 'flex' : 'none',
                                flex: 'none',
                                order: 2,
                                alignSelf: 'stretch',
                                flexGrow: 0,
                              }}
                            >
                              <div
                                className={`flex items-center gap-2 px-4 py-3 ${tabSelected !== 3 ? 'border-t-2 border-gray-100' : ''
                                  }`}
                              >
                                <PreferredByRecipient
                                  submissionBoardModel={selectedSubmissionBoard}
                                  sb_profiles_statuses={
                                    selecteProfileUser?.sb_profiles?.[0]?.sb_profiles_statuses
                                  }
                                  isTop={true}
                                  variant={'hor'}
                                  isPreferredBy={function (likecount: number): void {
                                    setisPreferredBy(likecount);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        {/* PreferredByRecipient  */}
                        {/* Buttons */}
                        {(fromScreen === fromRole.SB_CREATOR ||
                          fromScreen === fromRole.RECIPIENT ||
                          fromScreen === fromRole.SB_EXTERNAL_RECIPIENT) && (
                            <div
                              className="flex flex-col gap-4"
                              style={{
                                flex: 'none',
                                order: 3,
                                alignSelf: 'stretch',
                                flexGrow: 0,
                              }}
                            >
                              <div className="px-4 py-4 gap-2 flex flex-col">
                                {/* Final Selection Button */}
                                {!isSbLocked &&
                                  selecteProfileUser &&
                                  !isSelectionDoneHideAll() &&
                                  selecteProfileUser.sb_profiles[0].profile_status !==
                                  ProfileStatusMaster.Selected &&
                                  selecteProfileUser.sb_profiles[0].profile_status !==
                                  ProfileStatusMaster.Onboard &&
                                  !isMaxFinalSelectedReached() && (
                                    <Button
                                      id={'sb_detail_perf_final_accept_btn_id'}
                                      variant="primary"
                                      btn_size="small"
                                      icon_position="hor"
                                      className={` 
                                      ${isProfileHidden()
                                          ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                          : ''
                                        }`}
                                      disabled={isProfileHidden() || isServerOperation}
                                      onClick={() => {
                                        finalSelectionClickHandler();
                                      }}
                                    >
                                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                                        <CheckIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                      </div>
                                      Final Selection
                                    </Button>
                                  )}
                                {/* Final Selection Button */}
                                {/* Selected by, Add to team, Remove Selection start */}

                                {selecteProfileUser &&
                                  selecteProfileUser.sb_profiles[0].profile_status ==
                                  ProfileStatusMaster.Selected &&
                                  selecteProfileUser.sb_profiles[0].profile_status !==
                                  ProfileStatusMaster.Onboard && (
                                    <>
                                      {/* Selected or onboarded info button start */}
                                      <Button
                                        id={'sb_detail_perf_accepted_btn_id'}
                                        variant="primary"
                                        btn_size="small"
                                        icon_position="hor"
                                        className={`break-all w-full flex items-center justify-center gap-2 px-4 py-3 font-medium rounded-md
                                            ${selecteProfileUser.sb_profiles[0].profile_status ===
                                            ProfileStatusMaster.Onboard
                                            ? 'border-2 border-green-500 bg-mint-cream text-black'
                                            : 'border-2 border-blue-500 bg-heart-of-ice text-black'
                                          }`}
                                        disabled
                                      >
                                        <div
                                          className={`w-6 h-6 p-3px flex items-center justify-center"
                                                                    ${selecteProfileUser
                                              .sb_profiles[0]
                                              .profile_status ===
                                              ProfileStatusMaster.Onboard
                                              ? ' text-green-500 '
                                              : ' text-blue-500 '
                                            }`}
                                        >
                                          <CheckCircleIcon className="h-4-2 w-4-2" />
                                        </div>
                                        <span className="truncate flex-1" style={{}}>
                                          {getSelectedUser(
                                            selecteProfileUser.sb_profiles[0].updated_by,
                                            selecteProfileUser.sb_profiles[0].profile_status,
                                            selecteProfileUser.sb_profiles[0].sb_recipient_id
                                          )}
                                        </span>
                                      </Button>
                                      {/* Selected or onboarded info button start */}

                                      {/* only creator  */}
                                      {/* Add to Team start */}
                                      {fromScreen == fromRole.SB_CREATOR &&
                                        selecteProfileUser.sb_profiles[0].profile_status !==
                                        ProfileStatusMaster.Onboard && (
                                          <Button
                                            id={'sb_detail_perf_addteam_btn_id'}
                                            variant="primary"
                                            btn_size="small"
                                            icon_position="hor"
                                            className=""
                                            disabled={isServerOperation}
                                            onClick={() => {
                                              addToTeamClickHandler();
                                            }}
                                          >
                                            <div className="w-6 h-6 p-3px flex items-center justify-center">
                                              <PlusIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                            </div>
                                            <span className="truncate">Add to Team</span>
                                          </Button>
                                        )}
                                      {/* Add to Team end */}
                                      {/* remove selection start */}
                                      {!isSbLocked &&
                                        selecteProfileUser.sb_profiles[0].profile_status !==
                                        ProfileStatusMaster.Onboard && (
                                          <Button
                                            id={'sb_detail_perf_remove_select_btn_id'}
                                            type="button"
                                            variant="primary"
                                            btn_size="small"
                                            icon_position="hor"
                                            onClick={pendingClickHandler}
                                            disabled={isUpdating}
                                          >
                                            {isUpdating ? (
                                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
                                            ) : (
                                              <div className="w-6 h-6 p-3px flex items-center justify-center">
                                                <MinusCircleIcon
                                                  className="w-4-2 h-4-2"
                                                  aria-hidden="true"
                                                />
                                              </div>
                                            )}
                                            {isUpdating ? 'Removing...' : 'Remove Selection'}
                                          </Button>
                                        )}
                                      {/* remove selection start */}
                                    </>
                                  )}
                                {/* Selected by, Add to team, Remove Selection end */}
                              </div>
                            </div>
                          )}
                        {/* Buttons */}
                      </div>
                    )}
                  {/* CARD right profile info panel */}
                  {/* </div> */}
                </div>
                {/* Adaptable Button-Card FLOW  */}
              </div>
            </div>
          )}
        </div>
        {selecteProfileUser != null && submissionBoardModel != null && (
          <ConfirmationDialog
            title="Confirm Final Selection"
            description={
              "You are about to select <span class='font-bold'>" +
              selecteProfileUser.firstName +
              ' ' +
              selecteProfileUser.lastName +
              "</span>. This will be the final performer selection for <span class='font-bold'>" +
              submissionBoardModel.title +
              '</span>. Everyone will be notified that the role has been filled.<br/><br/>Are you sure this is your final choice?<br/><br/>'
            }
            onCancelLabel="Cancel"
            onCancelAction={confirmDialogActions?.onCancel}
            onConfirmLabel="Confirm"
            confirmVariant="primary"
            onConfirmAction={confirmDialogActions?.onConfirm}
            isOpen={showConfirmationModal}
            onClose={confirmDialogActions?.onCancel}
            icon={
              <div className="rounded-full p-3 bg-blue-200">
                <CheckCircleIcon className="w-6 h-6 text-blue-500 " />
              </div>
            }
          />
        )}
      </>
    );
  };

  const DialogPanel = () => {
    return (
      <>
        <div
          className={"relative flex h-full w-full flex-col gap-2-1  bg-white rounded-md" + 
            (fromScreen == fromRole.PROFILE_VIEWER ? '' : ' pt-5 pb-10 ')
          }
          style={{
            maxWidth: '71.25rem',
            maxHeight: '50rem',
            height: fromScreen == fromRole.PROFILE_VIEWER ? '42rem' : 'none',
          }}
          ref={panelRef}
          onTouchStart={handleTouchStartProfile}
          onTouchMove={handleTouchMoveProfile}
          onTouchEnd={handleTouchEndProfile}
        >
          {DialogPanelInnerRender()}
        </div>
      </>
    );
  };

  return (
    <>
      {' '}
      {fromScreen == fromRole.PROFILE_VIEWER ? (
        <>{DialogPanel()}</>
      ) : (
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={()=> {
            onCloseDialog(true);
          }}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 backdrop-blur-lg" />
            </Transition.Child>
            <div className="fixed inset-0 z-10 flex items-center justify-center p-5 sm:px-16 mt-12 sm:py-12 bg-gray-600 bg-opacity-80 backdrop-blur-sm transition-opacity">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel
                  className="relative flex h-full w-full flex-col gap-2-1 pt-5 pb-10 bg-white shadow-xl-0-19-40-8 rounded-md"
                  style={{
                    maxWidth: '71.25rem',
                    maxHeight: '50rem',
                    minHeight: fromScreen == fromRole.PROFILE_VIEWER ? '44rem' : 'none',
                  }}
                  ref={panelRef}
                  onTouchStart={handleTouchStartProfile}
                  onTouchMove={handleTouchMoveProfile}
                  onTouchEnd={handleTouchEndProfile}
                >
                  {DialogPanelInnerRender()}
                </Dialog.Panel>
              </Transition.Child>
            </div>
            {showMediaBig != null && (
              <>
                <ViewMediaModel
                  kit_document={showMediaBig}
                  dialogCloseHandler={function (): void {
                    setshowMediaBig(null);
                  }}
                />
              </>
            )}
          </Dialog>
        </Transition.Root>
      )}
      
    </>
  );
}
